<template>
  <div>
    <div id="mycard" class="card">

    <div class="card-header bg-transparent header-elements-sm-inline py-sm-0">

      <h5 class="card-title py-sm-3"><span class="icon-list"></span>&nbsp;&nbsp;Roll's List</h5>

      <div class="header-elements">
        <form action="#">
          <div class="form-group-feedback form-group-feedback-right">
            <input  id="txtsearch" type="search" class="form-control wmin-sm-200" placeholder="Search..." autocomplete="off">
            <div class="form-control-feedback">
              <i class="icon-search4 font-size-base text-muted"></i>
            </div>
          </div>
        </form>

      </div>
    </div>

    <div class="card-body" style="padding: 0px;">
      <div class="table-responsive">
        <table id="mytable"
               class="table  table-hover  table-bordered table-condensed table-columned"
               data-search="false"
               data-pagination="true"
               data-show-refresh="false"
               data-show-columns="false"
               data-page-list="[10, 25, 50, 100, ALL]"
               data-show-footer="false"
               data-page-size="All"
               data-toggle="context"
               data-target=".context-table">
          <thead>
            <tr>
              <th data-field="id" data-class="d-none">id</th>
              <th data-formatter="runningFormatter" data-width="75">S.No</th>
              <th data-field="id"  data-width="80" data-sortable="true">Roll No</th>
              <th data-field="roll_no" data-sortable="true" data-class="d-none">Roll No</th>
              <th data-field="status" data-width="70" data-sortable="true">Status</th>
              <th data-field="doc_date" data-width="110" data-formatter="dateFormatter" data-sortable="true">Date</th>
              <th data-field="quality.name" data-sortable="true">Quality</th>
              <th data-field="color.name" data-sortable="true">Color</th>
              <th data-field="qty" data-formatter="indianFormat4Value" data-width="70" data-sortable="true" data-align="right">Mtr</th>
              <th data-field="weight" data-formatter="weightFormat" data-width="100" data-sortable="true" data-align="right">Weight</th>
              <th data-field="avg" data-formatter="weightFormat" data-width="80" data-sortable="true" data-align="right">Avg</th>
              <th data-field="remarks" data-sortable="true">Remarks</th>
            </tr>
          </thead>
          <tbody>
          </tbody>
          <tfoot>
          </tfoot>
        </table>
      </div>

    </div>

    <!--    <div id="rolling_tabulator"></div>-->

    <!-- Context Menu -->
    <div id="context-menu" class="context-table">
      <div class="dropdown-menu">
        <a href="#" class="dropdown-item" @click="loadData"><i class="icon-reset" style="color: blue"></i>Refresh</a>
        <div class="dropdown-divider"></div>
        <!--<a href="#" class="dropdown-item" ><i class="icon-puzzle"></i>Breakup</a>-->
        <a href="#" class="dropdown-item" ><i class="icon-pencil7" style="color: #2d7330"></i>Modify</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item" ><i class="icon-blocked" style="color: orangered"></i>Remove</a>
      </div>
    </div>
    <!-- End of Context Menu -->

    <div>
      <vmodal name="rolling_window" transition="nice-modal-fade" :delay="100" :resizable="true" width="80%" height="85%" @click="showModal" >
        <RollingForm if="voucher.id > 0" v-bind:myvoucher="voucher" v-on:rolling_window_closed="closeModal" @rolling_saved="loadData"  ></RollingForm>
      </vmodal>
    </div>


      <!-- Clickable menu -->
      <ul class="fab-menu fab-menu-fixed fab-menu-bottom-right is_stuck" data-fab-toggle="hover" z-index="0">
        <li>
          <a class="fab-menu-btn btn bg-primary-600 btn-float rounded-round btn-icon" @click="showFilterWindow">
            <i class="fab-icon-open icon-filter3"></i>
            <i class="fab-icon-close icon-filter4"></i>
          </a>
        </li>
      </ul>
      <!-- /clickable menu -->

      <div>
        <vmodal name="filter-window" transition="nice-modal-fade" :delay="100" :resizable="true" :width="575" height="315" @opened="afterfilterwindow_visible">
          <form>
            <div class="card">
              <div class="card-header header-elements-inline bg-primary" style="padding: 10px;">
                <h3 class="card-title">Filter</h3>
                <div class="header-elements">
                  <div class="list-icons">
                    <!--<a class="list-icons-item" data-action="remove" @click="closeRequest"></a>-->
                  </div>
                </div>
              </div>

              <div class="card-body">

                <p/>

                <div class="form-group row">
                  <label class="col-md-3 col-form-label">From:</label>
                  <div class="col-md-3">
                    <input id= "txtfrom" ref= "txtfrom" type="date" class="form-control"  v-model="from_date" :max="upto_date" autofocus />
                  </div>

                  <label class="col-md-3 col-form-label">Upto</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control"  v-model="upto_date" :min="from_date" />
                  </div>
                </div>


                <div class="form-group row">
                  <label class="col-md-3 col-form-label">Quality:</label>
                  <div class="col-md-9">
                    <select id="cmbquality" class="form-control" v-model="quality_id" >
                      <option value="0" selected>All</option>
                      <option v-for="camp in qualities" v-bind:value="camp.id">
                        {{ camp.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-3 col-form-label">Color:</label>
                  <div class="col-md-9">
                    <select class="form-control" v-model="color_id" >
                      <option value="0" selected>All</option>
                      <option v-for="camp in colors" v-bind:value="camp.id">
                        {{ camp.name }}
                      </option>
                    </select>
                  </div>
                </div>


                <div class="text-right">
                  <button type="button" class="btn btn-outline alpha-success text-success-800 border-success-600 legitRipple" @click="loadData" >Show Data<i class="icon-database-refresh ml-2"></i></button>
                </div>

              </div>
            </div>
          </form>
        </vmodal>
      </div>

    </div>
  </div>
</template>

<script>
import RollingForm from '@/views/fms/rolling/RollingForm.vue'
import FabButton from '@/components/core/FabButton.vue'
import moment from 'moment-timezone'
import { userService } from '@/store/auth-header.js'
import { store } from '@/store/store.js'

export default {
  name: 'RollingView',
  store,
  components: {
    RollingForm,
    FabButton,
    moment
  },
  data () {
    return {
      voucher: JSON.parse('{"id":0,"status":"Active","finyear":0,"cmp_id":1,"shift":{"id":0,"type":0,"name":""},"doc_date":"2000-01-01","roll_no":0,"old_roll_no":0,"emp":{"id":0,"status":0,"emp_code":"","name":""},"process":{"code":350,"name":"","nature":0},"quality":{"id":0,"name":""},"color":{"id":0,"status":0,"name":""},"qty":0,"weight":0,"avg":0,"list":[],"remarks":""}'),
      mytable: {},
      from_date: moment().add(-7, 'days').format('YYYY-MM-DD'),
      upto_date: moment().format('YYYY-MM-DD'),
      quality_id : 0,
      qualities : [],
      color_id : 0,
      colors : [],
    }
  },
  created () {

  },
  mounted () {
    const self = this

    this.$data.mytable = $('#mytable')
    this.$data.mytable.bootstrapTable()


    $('#mytable').contextmenu({
      target: '#context-menu',
      scopes: 'tbody > tr',
      onItem: function (row, e) {

        let id = $(row.children('*')[0]).text()
        let code = $(row.children('*')[2]).text()

        if ($(e.target).text() === 'Refresh') {
          self.loadData()
        } else if ($(e.target).text() === 'Print') {
          self.printPreview(code)
        } else if ($(e.target).text() === 'Modify') {
          self.modifyDocument(id)
        } else if ($(e.target).text() == 'Remove') {
          self.removeDocument(id)
        }
      }
    })

    $('#txtsearch').keyup(function () {
      let val = $.trim($(this).val()).replace(/ +/g, ' ').toLowerCase()
      $('#mytable>tbody>tr').show().filter(function () {
        let text = $(this).text().replace(/\s+/g, ' ').toLowerCase()
        return !~text.indexOf(val)
      }).hide()
    });

    $('[data-action=remove]').click(function (e) {
      $('#rolling_window').modal('hide')
    })

    self.loadFilterData();
    self.$modal.show('filter-window');
  },
  methods: {
    afterfilterwindow_visible(){
      $('#txtfrom').focus();
    },
    showFilterWindow(){
      this.$modal.show('filter-window');
    },
    closeModal () {

      this.$modal.hide('rolling_window');
    },
    printPreview (id) {

      const self = this
      self.$modal.show('viewer-window')

      self.$data.voucher = self.$data.mytable.bootstrapTable('getRowByUniqueId', id)

      self.$data.voucher.date = self.$data.voucher.date.slice(0, 10).split('-').join('-');

      let report = {
        'Name': 'Report',
        'Type': 'report',
        'Width': '2in',
        'CustomProperties': [{ 'Name': 'DisplayType', 'Value': 'Page' }, { 'Name': 'SizeType', 'Value': 'Default' }],
        'Page': {
          'BottomMargin': '0in',
          'LeftMargin': '0in',
          'PageHeight': '3in',
          'PageWidth': '2in',
          'PageOrientation': 'Portrait',
          'RightMargin': '0in',
          'TopMargin': '0in',
          'ColumnSpacing': '0in',
          'Columns': 1
        },
        'Layers': [{ 'Type': 'layer', 'Name': 'default' }],
        'Body': {
          'Type': 'section',
          'Height': '2.75in',
          'Name': 'Body',
          'ReportItems': [{
            'KeepTogether': true,
            'Type': 'textbox',
            'Top': '0.25in',
            'Left': '1.0105in',
            'Width': '0.9687in',
            'Height': '0.25in',
            'CanGrow': true,
            'Value': '=Fields.Item("machine.p_name").Value',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'TextBox1'
          }, {
            'ZIndex': 2,
            'KeepTogether': true,
            'Type': 'textbox',
            'Top': '0.5104in',
            'Left': '0.0312in',
            'Width': '1.948in',
            'Height': '0.25in',
            'CanGrow': true,
            'Value': '=Fields!code.Value',
            'Style': {
              'TextAlign': 'Center',
              'VerticalAlign': 'Middle',
              'PaddingLeft': '2pt',
              'PaddingRight': '2pt',
              'PaddingTop': '2pt',
              'PaddingBottom': '2pt'
            },
            'Name': 'TextBox3'
          }, {
            'ZIndex': 3,
            'Type': 'barcode',
            'Top': '0.8646in',
            'Left': '0.5938in',
            'Width': '0.8542in',
            'Height': '0.8333in',
            'Style': { 'FontFamily': 'Courier New', 'FontSize': '8pt' },
            'Symbology': 'QRCode',
            'Value': '=Fields!code.Value',
            'Name': 'Barcode1'
          }, {
            'ZIndex': 4,
            'Type': 'inputfield',
            'Top': '1.75in',
            'Width': '1in',
            'Height': '0.25in',
            'Value': 'Quality',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'InputField1'
          }, {
            'ZIndex': 5,
            'Type': 'inputfield',
            'Top': '2in',
            'Width': '1in',
            'Height': '0.25in',
            'Value': 'Color',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'InputField2'
          }, {
            'ZIndex': 6,
            'Type': 'inputfield',
            'Top': '2.25in',
            'Width': '1in',
            'Height': '0.25in',
            'Value': 'Weight',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'InputField3'
          }, {
            'ZIndex': 7,
            'Type': 'inputfield',
            'Top': '2.5in',
            'Width': '1in',
            'Height': '0.25in',
            'Value': 'Date',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'InputField4'
          }, {
            'ZIndex': 12,
            'Type': 'inputfield',
            'Top': '0.25in',
            'Width': '1in',
            'Height': '0.25in',
            'Value': 'Machine',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'InputField9'
          }, {
            'ZIndex': 13,
            'KeepTogether': true,
            'Type': 'textbox',
            'Top': '1.75in',
            'Left': '1in',
            'Width': '1in',
            'Height': '0.25in',
            'CanGrow': true,
            'Value': '=Fields.Item("fabric.quality.p_name").Value',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'TextBox2'
          }, {
            'ZIndex': 14,
            'KeepTogether': true,
            'Type': 'textbox',
            'Top': '2in',
            'Left': '1in',
            'Width': '1in',
            'Height': '0.25in',
            'CanGrow': true,
            'Value': '=Fields.Item("fabric.color.p_name").Value',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'TextBox4'
          }, {
            'ZIndex': 15,
            'KeepTogether': true,
            'Type': 'textbox',
            'Top': '2.25in',
            'Left': '1in',
            'Width': '1in',
            'Height': '0.25in',
            'CanGrow': true,
            'Value': '=Fields!fab_wgt.Value',
            'Style': {
              'TextAlign': 'Left',
              'Format': 'n3',
              'PaddingLeft': '2pt',
              'PaddingRight': '2pt',
              'PaddingTop': '2pt',
              'PaddingBottom': '2pt'
            },
            'Name': 'TextBox5'
          }, {
            'ZIndex': 16,
            'KeepTogether': true,
            'Type': 'textbox',
            'Top': '2.5in',
            'Left': '1in',
            'Width': '1in',
            'Height': '0.25in',
            'CanGrow': true,
            'Value': '=Fields!date.Value',
            'Style': {
              'PaddingLeft': '2pt',
              'PaddingRight': '2pt',
              'PaddingTop': '2pt',
              'PaddingBottom': '2pt',
              'Format': 'd'
            },
            'Name': 'TextBox6'
          }]
        },
        'DataSources': [{
          'Name': 'DataSource', 'Transaction': false, 'DataSourceReference': '', 'ConnectionProperties': {
            'DataProvider': 'JSONEMBED',
            'ConnectString': 'jsondata={\\r\\n  "id": "",\\r\\n  "code": 0,\\r\\n  "status": 0,\\r\\n  "type": 0,\\r\\n  "is_cr": "",\\r\\n  "finyear": 2020,\\r\\n  "doc_no": 0,\\r\\n  "machine": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "type": 0,\\r\\n    "nature": 0,\\r\\n    "name": "",\\r\\n    "p_name": "A40"\\r\\n  },\\r\\n  "shift": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "type": 0,\\r\\n    "name": ""\\r\\n  },\\r\\n  "operator": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "status": 0,\\r\\n    "emp_code": "",\\r\\n    "name": "",\\r\\n    "designation": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "min_wage": 0\\r\\n    }\\r\\n  },\\r\\n  "date": "0001-01-01",\\r\\n  "color": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "status": 0,\\r\\n    "name": "Light Green",\\r\\n    "p_name": "Light Green",\\r\\n    "wgt": 0,\\r\\n    "chart": []\\r\\n  },\\r\\n  "quality": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "name": "Madhu",\\r\\n    "p_name": "Madhu",\\r\\n    "colors_wgt": []\\r\\n  },\\r\\n  "fabric": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "nature": 0,\\r\\n    "ledger_group": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "status": 0,\\r\\n      "type": 0,\\r\\n      "name": "",\\r\\n      "alias": "",\\r\\n      "print_name": "",\\r\\n      "parent_code": 0,\\r\\n      "nature": 0,\\r\\n      "affect_profit": false,\\r\\n      "behave_like_sub_ledger": false,\\r\\n      "net_cr_dr_balance": false,\\r\\n      "used_for_calculation": false,\\r\\n      "system_object": false\\r\\n    },\\r\\n    "name": "",\\r\\n    "p_name": "",\\r\\n    "process": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "nature": 0,\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "group": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "type": 0,\\r\\n      "nature": 0,\\r\\n      "name": "",\\r\\n      "p_name": "",\\r\\n      "hsn": "",\\r\\n      "gstrate": 0,\\r\\n      "itcrate": 0,\\r\\n      "unit": {\\r\\n        "id": "",\\r\\n        "code": 0,\\r\\n        "name": "",\\r\\n        "digits": 0\\r\\n      },\\r\\n      "subunit": {\\r\\n        "id": "",\\r\\n        "code": 0,\\r\\n        "name": "",\\r\\n        "digits": 0\\r\\n      },\\r\\n      "conv_fact": 0,\\r\\n      "has_bom": false,\\r\\n      "sysobj": false\\r\\n    },\\r\\n    "design": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "color": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "status": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "quality": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "category": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "brand": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "print_name": ""\\r\\n    },\\r\\n    "style": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "unit": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "digits": 0\\r\\n    },\\r\\n    "rate": 0,\\r\\n    "min_qty": 0,\\r\\n    "max_qty": 0,\\r\\n    "wgt": 0\\r\\n  },\\r\\n  "fab_wgt": 25,\\r\\n  "yarn_waste": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "nature": 0,\\r\\n    "ledger_group": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "status": 0,\\r\\n      "type": 0,\\r\\n      "name": "",\\r\\n      "alias": "",\\r\\n      "print_name": "",\\r\\n      "parent_code": 0,\\r\\n      "nature": 0,\\r\\n      "affect_profit": false,\\r\\n      "behave_like_sub_ledger": false,\\r\\n      "net_cr_dr_balance": false,\\r\\n      "used_for_calculation": false,\\r\\n      "system_object": false\\r\\n    },\\r\\n    "name": "",\\r\\n    "p_name": "",\\r\\n    "process": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "nature": 0,\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "group": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "type": 0,\\r\\n      "nature": 0,\\r\\n      "name": "",\\r\\n      "p_name": "",\\r\\n      "hsn": "",\\r\\n      "gstrate": 0,\\r\\n      "itcrate": 0,\\r\\n      "unit": {\\r\\n        "id": "",\\r\\n        "code": 0,\\r\\n        "name": "",\\r\\n        "digits": 0\\r\\n      },\\r\\n      "subunit": {\\r\\n        "id": "",\\r\\n        "code": 0,\\r\\n        "name": "",\\r\\n        "digits": 0\\r\\n      },\\r\\n      "conv_fact": 0,\\r\\n      "has_bom": false,\\r\\n      "sysobj": false\\r\\n    },\\r\\n    "design": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "color": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "status": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "quality": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "category": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "brand": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "print_name": ""\\r\\n    },\\r\\n    "style": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "unit": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "digits": 0\\r\\n    },\\r\\n    "rate": 0,\\r\\n    "min_qty": 0,\\r\\n    "max_qty": 0,\\r\\n    "wgt": 0\\r\\n  },\\r\\n  "yarn_waste_wgt": 0,\\r\\n  "fab_waste": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "nature": 0,\\r\\n    "ledger_group": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "status": 0,\\r\\n      "type": 0,\\r\\n      "name": "",\\r\\n      "alias": "",\\r\\n      "print_name": "",\\r\\n      "parent_code": 0,\\r\\n      "nature": 0,\\r\\n      "affect_profit": false,\\r\\n      "behave_like_sub_ledger": false,\\r\\n      "net_cr_dr_balance": false,\\r\\n      "used_for_calculation": false,\\r\\n      "system_object": false\\r\\n    },\\r\\n    "name": "",\\r\\n    "p_name": "",\\r\\n    "process": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "nature": 0,\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "group": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "type": 0,\\r\\n      "nature": 0,\\r\\n      "name": "",\\r\\n      "p_name": "",\\r\\n      "hsn": "",\\r\\n      "gstrate": 0,\\r\\n      "itcrate": 0,\\r\\n      "unit": {\\r\\n        "id": "",\\r\\n        "code": 0,\\r\\n        "name": "",\\r\\n        "digits": 0\\r\\n      },\\r\\n      "subunit": {\\r\\n        "id": "",\\r\\n        "code": 0,\\r\\n        "name": "",\\r\\n        "digits": 0\\r\\n      },\\r\\n      "conv_fact": 0,\\r\\n      "has_bom": false,\\r\\n      "sysobj": false\\r\\n    },\\r\\n    "design": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "color": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "status": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "quality": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "category": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "brand": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "print_name": ""\\r\\n    },\\r\\n    "style": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "unit": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "digits": 0\\r\\n    },\\r\\n    "rate": 0,\\r\\n    "min_qty": 0,\\r\\n    "max_qty": 0,\\r\\n    "wgt": 0\\r\\n  },\\r\\n  "fab_waste_wgt": 0,\\r\\n  "defects_count": 0,\\r\\n  "remarks": ""\\r\\n}',
            'IntegratedSecurity': false,
            'Prompt': '',
            'Collation': '',
            'AccentSensivity': 'Auto',
            'WidthSensivity': 'Auto'
          }
        }],
        'DataSets': [{
          'Name': 'DataSet',
          'Fields': [{ 'Name': 'id', 'DataField': 'id' }, { 'Name': 'code', 'DataField': 'code' }, {
            'Name': 'status',
            'DataField': 'status'
          }, { 'Name': 'type', 'DataField': 'type' }, { 'Name': 'is_cr', 'DataField': 'is_cr' }, {
            'Name': 'finyear',
            'DataField': 'finyear'
          }, { 'Name': 'doc_no', 'DataField': 'doc_no' }, {
            'Name': 'machine.id',
            'DataField': 'machine.id'
          }, { 'Name': 'machine.code', 'DataField': 'machine.code' }, {
            'Name': 'machine.type',
            'DataField': 'machine.type'
          }, { 'Name': 'machine.nature', 'DataField': 'machine.nature' }, {
            'Name': 'machine.name',
            'DataField': 'machine.name'
          }, { 'Name': 'machine.p_name', 'DataField': 'machine.p_name' }, {
            'Name': 'shift.id',
            'DataField': 'shift.id'
          }, { 'Name': 'shift.code', 'DataField': 'shift.code' }, {
            'Name': 'shift.type',
            'DataField': 'shift.type'
          }, { 'Name': 'shift.name', 'DataField': 'shift.name' }, {
            'Name': 'operator.id',
            'DataField': 'operator.id'
          }, { 'Name': 'operator.code', 'DataField': 'operator.code' }, {
            'Name': 'operator.status',
            'DataField': 'operator.status'
          }, { 'Name': 'operator.emp_code', 'DataField': 'operator.emp_code' }, {
            'Name': 'operator.name',
            'DataField': 'operator.name'
          }, {
            'Name': 'operator.designation.id',
            'DataField': 'operator.designation.id'
          }, {
            'Name': 'operator.designation.code',
            'DataField': 'operator.designation.code'
          }, {
            'Name': 'operator.designation.name',
            'DataField': 'operator.designation.name'
          }, {
            'Name': 'operator.designation.min_wage',
            'DataField': 'operator.designation.min_wage'
          }, { 'Name': 'date', 'DataField': 'date' }, {
            'Name': 'color.id',
            'DataField': 'color.id'
          }, { 'Name': 'color.code', 'DataField': 'color.code' }, {
            'Name': 'color.status',
            'DataField': 'color.status'
          }, { 'Name': 'color.name', 'DataField': 'color.name' }, {
            'Name': 'color.p_name',
            'DataField': 'color.p_name'
          }, { 'Name': 'color.wgt', 'DataField': 'color.wgt' }, {
            'Name': 'color.chart',
            'DataField': 'color.chart'
          }, { 'Name': 'quality.id', 'DataField': 'quality.id' }, {
            'Name': 'quality.code',
            'DataField': 'quality.code'
          }, { 'Name': 'quality.name', 'DataField': 'quality.name' }, {
            'Name': 'quality.p_name',
            'DataField': 'quality.p_name'
          }, { 'Name': 'quality.colors_wgt', 'DataField': 'quality.colors_wgt' }, {
            'Name': 'fabric.id',
            'DataField': 'fabric.id'
          }, { 'Name': 'fabric.code', 'DataField': 'fabric.code' }, {
            'Name': 'fabric.nature',
            'DataField': 'fabric.nature'
          }, {
            'Name': 'fabric.ledger_group.id',
            'DataField': 'fabric.ledger_group.id'
          }, {
            'Name': 'fabric.ledger_group.code',
            'DataField': 'fabric.ledger_group.code'
          }, {
            'Name': 'fabric.ledger_group.status',
            'DataField': 'fabric.ledger_group.status'
          }, {
            'Name': 'fabric.ledger_group.type',
            'DataField': 'fabric.ledger_group.type'
          }, {
            'Name': 'fabric.ledger_group.name',
            'DataField': 'fabric.ledger_group.name'
          }, {
            'Name': 'fabric.ledger_group.alias',
            'DataField': 'fabric.ledger_group.alias'
          }, {
            'Name': 'fabric.ledger_group.print_name',
            'DataField': 'fabric.ledger_group.print_name'
          }, {
            'Name': 'fabric.ledger_group.parent_code',
            'DataField': 'fabric.ledger_group.parent_code'
          }, {
            'Name': 'fabric.ledger_group.nature',
            'DataField': 'fabric.ledger_group.nature'
          }, {
            'Name': 'fabric.ledger_group.affect_profit',
            'DataField': 'fabric.ledger_group.affect_profit'
          }, {
            'Name': 'fabric.ledger_group.behave_like_sub_ledger',
            'DataField': 'fabric.ledger_group.behave_like_sub_ledger'
          }, {
            'Name': 'fabric.ledger_group.net_cr_dr_balance',
            'DataField': 'fabric.ledger_group.net_cr_dr_balance'
          }, {
            'Name': 'fabric.ledger_group.used_for_calculation',
            'DataField': 'fabric.ledger_group.used_for_calculation'
          }, {
            'Name': 'fabric.ledger_group.system_object',
            'DataField': 'fabric.ledger_group.system_object'
          }, { 'Name': 'fabric.name', 'DataField': 'fabric.name' }, {
            'Name': 'fabric.p_name',
            'DataField': 'fabric.p_name'
          }, { 'Name': 'fabric.process.id', 'DataField': 'fabric.process.id' }, {
            'Name': 'fabric.process.code',
            'DataField': 'fabric.process.code'
          }, { 'Name': 'fabric.process.name', 'DataField': 'fabric.process.name' }, {
            'Name': 'fabric.process.nature',
            'DataField': 'fabric.process.nature'
          }, { 'Name': 'fabric.process.p_name', 'DataField': 'fabric.process.p_name' }, {
            'Name': 'fabric.group.id',
            'DataField': 'fabric.group.id'
          }, { 'Name': 'fabric.group.code', 'DataField': 'fabric.group.code' }, {
            'Name': 'fabric.group.type',
            'DataField': 'fabric.group.type'
          }, { 'Name': 'fabric.group.nature', 'DataField': 'fabric.group.nature' }, {
            'Name': 'fabric.group.name',
            'DataField': 'fabric.group.name'
          }, { 'Name': 'fabric.group.p_name', 'DataField': 'fabric.group.p_name' }, {
            'Name': 'fabric.group.hsn',
            'DataField': 'fabric.group.hsn'
          }, { 'Name': 'fabric.group.gstrate', 'DataField': 'fabric.group.gstrate' }, {
            'Name': 'fabric.group.itcrate',
            'DataField': 'fabric.group.itcrate'
          }, {
            'Name': 'fabric.group.unit.id',
            'DataField': 'fabric.group.unit.id'
          }, {
            'Name': 'fabric.group.unit.code',
            'DataField': 'fabric.group.unit.code'
          }, {
            'Name': 'fabric.group.unit.name',
            'DataField': 'fabric.group.unit.name'
          }, {
            'Name': 'fabric.group.unit.digits',
            'DataField': 'fabric.group.unit.digits'
          }, {
            'Name': 'fabric.group.subunit.id',
            'DataField': 'fabric.group.subunit.id'
          }, {
            'Name': 'fabric.group.subunit.code',
            'DataField': 'fabric.group.subunit.code'
          }, {
            'Name': 'fabric.group.subunit.name',
            'DataField': 'fabric.group.subunit.name'
          }, {
            'Name': 'fabric.group.subunit.digits',
            'DataField': 'fabric.group.subunit.digits'
          }, {
            'Name': 'fabric.group.conv_fact',
            'DataField': 'fabric.group.conv_fact'
          }, { 'Name': 'fabric.group.has_bom', 'DataField': 'fabric.group.has_bom' }, {
            'Name': 'fabric.group.sysobj',
            'DataField': 'fabric.group.sysobj'
          }, { 'Name': 'fabric.design.id', 'DataField': 'fabric.design.id' }, {
            'Name': 'fabric.design.code',
            'DataField': 'fabric.design.code'
          }, { 'Name': 'fabric.design.name', 'DataField': 'fabric.design.name' }, {
            'Name': 'fabric.design.p_name',
            'DataField': 'fabric.design.p_name'
          }, { 'Name': 'fabric.color.id', 'DataField': 'fabric.color.id' }, {
            'Name': 'fabric.color.code',
            'DataField': 'fabric.color.code'
          }, { 'Name': 'fabric.color.status', 'DataField': 'fabric.color.status' }, {
            'Name': 'fabric.color.name',
            'DataField': 'fabric.color.name'
          }, { 'Name': 'fabric.color.p_name', 'DataField': 'fabric.color.p_name' }, {
            'Name': 'fabric.quality.id',
            'DataField': 'fabric.quality.id'
          }, { 'Name': 'fabric.quality.code', 'DataField': 'fabric.quality.code' }, {
            'Name': 'fabric.quality.name',
            'DataField': 'fabric.quality.name'
          }, { 'Name': 'fabric.quality.p_name', 'DataField': 'fabric.quality.p_name' }, {
            'Name': 'fabric.category.id',
            'DataField': 'fabric.category.id'
          }, { 'Name': 'fabric.category.code', 'DataField': 'fabric.category.code' }, {
            'Name': 'fabric.category.name',
            'DataField': 'fabric.category.name'
          }, { 'Name': 'fabric.category.p_name', 'DataField': 'fabric.category.p_name' }, {
            'Name': 'fabric.brand.id',
            'DataField': 'fabric.brand.id'
          }, { 'Name': 'fabric.brand.code', 'DataField': 'fabric.brand.code' }, {
            'Name': 'fabric.brand.name',
            'DataField': 'fabric.brand.name'
          }, { 'Name': 'fabric.brand.print_name', 'DataField': 'fabric.brand.print_name' }, {
            'Name': 'fabric.style.id',
            'DataField': 'fabric.style.id'
          }, { 'Name': 'fabric.style.code', 'DataField': 'fabric.style.code' }, {
            'Name': 'fabric.style.name',
            'DataField': 'fabric.style.name'
          }, { 'Name': 'fabric.style.p_name', 'DataField': 'fabric.style.p_name' }, {
            'Name': 'fabric.unit.id',
            'DataField': 'fabric.unit.id'
          }, { 'Name': 'fabric.unit.code', 'DataField': 'fabric.unit.code' }, {
            'Name': 'fabric.unit.name',
            'DataField': 'fabric.unit.name'
          }, { 'Name': 'fabric.unit.digits', 'DataField': 'fabric.unit.digits' }, {
            'Name': 'fabric.rate',
            'DataField': 'fabric.rate'
          }, { 'Name': 'fabric.min_qty', 'DataField': 'fabric.min_qty' }, {
            'Name': 'fabric.max_qty',
            'DataField': 'fabric.max_qty'
          }, { 'Name': 'fabric.wgt', 'DataField': 'fabric.wgt' }, {
            'Name': 'fab_wgt',
            'DataField': 'fab_wgt'
          }, { 'Name': 'yarn_waste.id', 'DataField': 'yarn_waste.id' }, {
            'Name': 'yarn_waste.code',
            'DataField': 'yarn_waste.code'
          }, { 'Name': 'yarn_waste.nature', 'DataField': 'yarn_waste.nature' }, {
            'Name': 'yarn_waste.ledger_group.id',
            'DataField': 'yarn_waste.ledger_group.id'
          }, {
            'Name': 'yarn_waste.ledger_group.code',
            'DataField': 'yarn_waste.ledger_group.code'
          }, {
            'Name': 'yarn_waste.ledger_group.status',
            'DataField': 'yarn_waste.ledger_group.status'
          }, {
            'Name': 'yarn_waste.ledger_group.type',
            'DataField': 'yarn_waste.ledger_group.type'
          }, {
            'Name': 'yarn_waste.ledger_group.name',
            'DataField': 'yarn_waste.ledger_group.name'
          }, {
            'Name': 'yarn_waste.ledger_group.alias',
            'DataField': 'yarn_waste.ledger_group.alias'
          }, {
            'Name': 'yarn_waste.ledger_group.print_name',
            'DataField': 'yarn_waste.ledger_group.print_name'
          }, {
            'Name': 'yarn_waste.ledger_group.parent_code',
            'DataField': 'yarn_waste.ledger_group.parent_code'
          }, {
            'Name': 'yarn_waste.ledger_group.nature',
            'DataField': 'yarn_waste.ledger_group.nature'
          }, {
            'Name': 'yarn_waste.ledger_group.affect_profit',
            'DataField': 'yarn_waste.ledger_group.affect_profit'
          }, {
            'Name': 'yarn_waste.ledger_group.behave_like_sub_ledger',
            'DataField': 'yarn_waste.ledger_group.behave_like_sub_ledger'
          }, {
            'Name': 'yarn_waste.ledger_group.net_cr_dr_balance',
            'DataField': 'yarn_waste.ledger_group.net_cr_dr_balance'
          }, {
            'Name': 'yarn_waste.ledger_group.used_for_calculation',
            'DataField': 'yarn_waste.ledger_group.used_for_calculation'
          }, {
            'Name': 'yarn_waste.ledger_group.system_object',
            'DataField': 'yarn_waste.ledger_group.system_object'
          }, { 'Name': 'yarn_waste.name', 'DataField': 'yarn_waste.name' }, {
            'Name': 'yarn_waste.p_name',
            'DataField': 'yarn_waste.p_name'
          }, {
            'Name': 'yarn_waste.process.id',
            'DataField': 'yarn_waste.process.id'
          }, {
            'Name': 'yarn_waste.process.code',
            'DataField': 'yarn_waste.process.code'
          }, {
            'Name': 'yarn_waste.process.name',
            'DataField': 'yarn_waste.process.name'
          }, {
            'Name': 'yarn_waste.process.nature',
            'DataField': 'yarn_waste.process.nature'
          }, {
            'Name': 'yarn_waste.process.p_name',
            'DataField': 'yarn_waste.process.p_name'
          }, { 'Name': 'yarn_waste.group.id', 'DataField': 'yarn_waste.group.id' }, {
            'Name': 'yarn_waste.group.code',
            'DataField': 'yarn_waste.group.code'
          }, {
            'Name': 'yarn_waste.group.type',
            'DataField': 'yarn_waste.group.type'
          }, {
            'Name': 'yarn_waste.group.nature',
            'DataField': 'yarn_waste.group.nature'
          }, {
            'Name': 'yarn_waste.group.name',
            'DataField': 'yarn_waste.group.name'
          }, {
            'Name': 'yarn_waste.group.p_name',
            'DataField': 'yarn_waste.group.p_name'
          }, {
            'Name': 'yarn_waste.group.hsn',
            'DataField': 'yarn_waste.group.hsn'
          }, {
            'Name': 'yarn_waste.group.gstrate',
            'DataField': 'yarn_waste.group.gstrate'
          }, {
            'Name': 'yarn_waste.group.itcrate',
            'DataField': 'yarn_waste.group.itcrate'
          }, {
            'Name': 'yarn_waste.group.unit.id',
            'DataField': 'yarn_waste.group.unit.id'
          }, {
            'Name': 'yarn_waste.group.unit.code',
            'DataField': 'yarn_waste.group.unit.code'
          }, {
            'Name': 'yarn_waste.group.unit.name',
            'DataField': 'yarn_waste.group.unit.name'
          }, {
            'Name': 'yarn_waste.group.unit.digits',
            'DataField': 'yarn_waste.group.unit.digits'
          }, {
            'Name': 'yarn_waste.group.subunit.id',
            'DataField': 'yarn_waste.group.subunit.id'
          }, {
            'Name': 'yarn_waste.group.subunit.code',
            'DataField': 'yarn_waste.group.subunit.code'
          }, {
            'Name': 'yarn_waste.group.subunit.name',
            'DataField': 'yarn_waste.group.subunit.name'
          }, {
            'Name': 'yarn_waste.group.subunit.digits',
            'DataField': 'yarn_waste.group.subunit.digits'
          }, {
            'Name': 'yarn_waste.group.conv_fact',
            'DataField': 'yarn_waste.group.conv_fact'
          }, {
            'Name': 'yarn_waste.group.has_bom',
            'DataField': 'yarn_waste.group.has_bom'
          }, {
            'Name': 'yarn_waste.group.sysobj',
            'DataField': 'yarn_waste.group.sysobj'
          }, {
            'Name': 'yarn_waste.design.id',
            'DataField': 'yarn_waste.design.id'
          }, {
            'Name': 'yarn_waste.design.code',
            'DataField': 'yarn_waste.design.code'
          }, {
            'Name': 'yarn_waste.design.name',
            'DataField': 'yarn_waste.design.name'
          }, {
            'Name': 'yarn_waste.design.p_name',
            'DataField': 'yarn_waste.design.p_name'
          }, { 'Name': 'yarn_waste.color.id', 'DataField': 'yarn_waste.color.id' }, {
            'Name': 'yarn_waste.color.code',
            'DataField': 'yarn_waste.color.code'
          }, {
            'Name': 'yarn_waste.color.status',
            'DataField': 'yarn_waste.color.status'
          }, {
            'Name': 'yarn_waste.color.name',
            'DataField': 'yarn_waste.color.name'
          }, {
            'Name': 'yarn_waste.color.p_name',
            'DataField': 'yarn_waste.color.p_name'
          }, {
            'Name': 'yarn_waste.quality.id',
            'DataField': 'yarn_waste.quality.id'
          }, {
            'Name': 'yarn_waste.quality.code',
            'DataField': 'yarn_waste.quality.code'
          }, {
            'Name': 'yarn_waste.quality.name',
            'DataField': 'yarn_waste.quality.name'
          }, {
            'Name': 'yarn_waste.quality.p_name',
            'DataField': 'yarn_waste.quality.p_name'
          }, {
            'Name': 'yarn_waste.category.id',
            'DataField': 'yarn_waste.category.id'
          }, {
            'Name': 'yarn_waste.category.code',
            'DataField': 'yarn_waste.category.code'
          }, {
            'Name': 'yarn_waste.category.name',
            'DataField': 'yarn_waste.category.name'
          }, {
            'Name': 'yarn_waste.category.p_name',
            'DataField': 'yarn_waste.category.p_name'
          }, { 'Name': 'yarn_waste.brand.id', 'DataField': 'yarn_waste.brand.id' }, {
            'Name': 'yarn_waste.brand.code',
            'DataField': 'yarn_waste.brand.code'
          }, {
            'Name': 'yarn_waste.brand.name',
            'DataField': 'yarn_waste.brand.name'
          }, {
            'Name': 'yarn_waste.brand.print_name',
            'DataField': 'yarn_waste.brand.print_name'
          }, { 'Name': 'yarn_waste.style.id', 'DataField': 'yarn_waste.style.id' }, {
            'Name': 'yarn_waste.style.code',
            'DataField': 'yarn_waste.style.code'
          }, {
            'Name': 'yarn_waste.style.name',
            'DataField': 'yarn_waste.style.name'
          }, {
            'Name': 'yarn_waste.style.p_name',
            'DataField': 'yarn_waste.style.p_name'
          }, { 'Name': 'yarn_waste.unit.id', 'DataField': 'yarn_waste.unit.id' }, {
            'Name': 'yarn_waste.unit.code',
            'DataField': 'yarn_waste.unit.code'
          }, {
            'Name': 'yarn_waste.unit.name',
            'DataField': 'yarn_waste.unit.name'
          }, { 'Name': 'yarn_waste.unit.digits', 'DataField': 'yarn_waste.unit.digits' }, {
            'Name': 'yarn_waste.rate',
            'DataField': 'yarn_waste.rate'
          }, { 'Name': 'yarn_waste.min_qty', 'DataField': 'yarn_waste.min_qty' }, {
            'Name': 'yarn_waste.max_qty',
            'DataField': 'yarn_waste.max_qty'
          }, { 'Name': 'yarn_waste.wgt', 'DataField': 'yarn_waste.wgt' }, {
            'Name': 'yarn_waste_wgt',
            'DataField': 'yarn_waste_wgt'
          }, { 'Name': 'fab_waste.id', 'DataField': 'fab_waste.id' }, {
            'Name': 'fab_waste.code',
            'DataField': 'fab_waste.code'
          }, { 'Name': 'fab_waste.nature', 'DataField': 'fab_waste.nature' }, {
            'Name': 'fab_waste.ledger_group.id',
            'DataField': 'fab_waste.ledger_group.id'
          }, {
            'Name': 'fab_waste.ledger_group.code',
            'DataField': 'fab_waste.ledger_group.code'
          }, {
            'Name': 'fab_waste.ledger_group.status',
            'DataField': 'fab_waste.ledger_group.status'
          }, {
            'Name': 'fab_waste.ledger_group.type',
            'DataField': 'fab_waste.ledger_group.type'
          }, {
            'Name': 'fab_waste.ledger_group.name',
            'DataField': 'fab_waste.ledger_group.name'
          }, {
            'Name': 'fab_waste.ledger_group.alias',
            'DataField': 'fab_waste.ledger_group.alias'
          }, {
            'Name': 'fab_waste.ledger_group.print_name',
            'DataField': 'fab_waste.ledger_group.print_name'
          }, {
            'Name': 'fab_waste.ledger_group.parent_code',
            'DataField': 'fab_waste.ledger_group.parent_code'
          }, {
            'Name': 'fab_waste.ledger_group.nature',
            'DataField': 'fab_waste.ledger_group.nature'
          }, {
            'Name': 'fab_waste.ledger_group.affect_profit',
            'DataField': 'fab_waste.ledger_group.affect_profit'
          }, {
            'Name': 'fab_waste.ledger_group.behave_like_sub_ledger',
            'DataField': 'fab_waste.ledger_group.behave_like_sub_ledger'
          }, {
            'Name': 'fab_waste.ledger_group.net_cr_dr_balance',
            'DataField': 'fab_waste.ledger_group.net_cr_dr_balance'
          }, {
            'Name': 'fab_waste.ledger_group.used_for_calculation',
            'DataField': 'fab_waste.ledger_group.used_for_calculation'
          }, {
            'Name': 'fab_waste.ledger_group.system_object',
            'DataField': 'fab_waste.ledger_group.system_object'
          }, { 'Name': 'fab_waste.name', 'DataField': 'fab_waste.name' }, {
            'Name': 'fab_waste.p_name',
            'DataField': 'fab_waste.p_name'
          }, {
            'Name': 'fab_waste.process.id',
            'DataField': 'fab_waste.process.id'
          }, {
            'Name': 'fab_waste.process.code',
            'DataField': 'fab_waste.process.code'
          }, {
            'Name': 'fab_waste.process.name',
            'DataField': 'fab_waste.process.name'
          }, {
            'Name': 'fab_waste.process.nature',
            'DataField': 'fab_waste.process.nature'
          }, {
            'Name': 'fab_waste.process.p_name',
            'DataField': 'fab_waste.process.p_name'
          }, { 'Name': 'fab_waste.group.id', 'DataField': 'fab_waste.group.id' }, {
            'Name': 'fab_waste.group.code',
            'DataField': 'fab_waste.group.code'
          }, {
            'Name': 'fab_waste.group.type',
            'DataField': 'fab_waste.group.type'
          }, {
            'Name': 'fab_waste.group.nature',
            'DataField': 'fab_waste.group.nature'
          }, {
            'Name': 'fab_waste.group.name',
            'DataField': 'fab_waste.group.name'
          }, {
            'Name': 'fab_waste.group.p_name',
            'DataField': 'fab_waste.group.p_name'
          }, { 'Name': 'fab_waste.group.hsn', 'DataField': 'fab_waste.group.hsn' }, {
            'Name': 'fab_waste.group.gstrate',
            'DataField': 'fab_waste.group.gstrate'
          }, {
            'Name': 'fab_waste.group.itcrate',
            'DataField': 'fab_waste.group.itcrate'
          }, {
            'Name': 'fab_waste.group.unit.id',
            'DataField': 'fab_waste.group.unit.id'
          }, {
            'Name': 'fab_waste.group.unit.code',
            'DataField': 'fab_waste.group.unit.code'
          }, {
            'Name': 'fab_waste.group.unit.name',
            'DataField': 'fab_waste.group.unit.name'
          }, {
            'Name': 'fab_waste.group.unit.digits',
            'DataField': 'fab_waste.group.unit.digits'
          }, {
            'Name': 'fab_waste.group.subunit.id',
            'DataField': 'fab_waste.group.subunit.id'
          }, {
            'Name': 'fab_waste.group.subunit.code',
            'DataField': 'fab_waste.group.subunit.code'
          }, {
            'Name': 'fab_waste.group.subunit.name',
            'DataField': 'fab_waste.group.subunit.name'
          }, {
            'Name': 'fab_waste.group.subunit.digits',
            'DataField': 'fab_waste.group.subunit.digits'
          }, {
            'Name': 'fab_waste.group.conv_fact',
            'DataField': 'fab_waste.group.conv_fact'
          }, {
            'Name': 'fab_waste.group.has_bom',
            'DataField': 'fab_waste.group.has_bom'
          }, {
            'Name': 'fab_waste.group.sysobj',
            'DataField': 'fab_waste.group.sysobj'
          }, { 'Name': 'fab_waste.design.id', 'DataField': 'fab_waste.design.id' }, {
            'Name': 'fab_waste.design.code',
            'DataField': 'fab_waste.design.code'
          }, {
            'Name': 'fab_waste.design.name',
            'DataField': 'fab_waste.design.name'
          }, {
            'Name': 'fab_waste.design.p_name',
            'DataField': 'fab_waste.design.p_name'
          }, { 'Name': 'fab_waste.color.id', 'DataField': 'fab_waste.color.id' }, {
            'Name': 'fab_waste.color.code',
            'DataField': 'fab_waste.color.code'
          }, {
            'Name': 'fab_waste.color.status',
            'DataField': 'fab_waste.color.status'
          }, {
            'Name': 'fab_waste.color.name',
            'DataField': 'fab_waste.color.name'
          }, {
            'Name': 'fab_waste.color.p_name',
            'DataField': 'fab_waste.color.p_name'
          }, {
            'Name': 'fab_waste.quality.id',
            'DataField': 'fab_waste.quality.id'
          }, {
            'Name': 'fab_waste.quality.code',
            'DataField': 'fab_waste.quality.code'
          }, {
            'Name': 'fab_waste.quality.name',
            'DataField': 'fab_waste.quality.name'
          }, {
            'Name': 'fab_waste.quality.p_name',
            'DataField': 'fab_waste.quality.p_name'
          }, {
            'Name': 'fab_waste.category.id',
            'DataField': 'fab_waste.category.id'
          }, {
            'Name': 'fab_waste.category.code',
            'DataField': 'fab_waste.category.code'
          }, {
            'Name': 'fab_waste.category.name',
            'DataField': 'fab_waste.category.name'
          }, {
            'Name': 'fab_waste.category.p_name',
            'DataField': 'fab_waste.category.p_name'
          }, { 'Name': 'fab_waste.brand.id', 'DataField': 'fab_waste.brand.id' }, {
            'Name': 'fab_waste.brand.code',
            'DataField': 'fab_waste.brand.code'
          }, {
            'Name': 'fab_waste.brand.name',
            'DataField': 'fab_waste.brand.name'
          }, {
            'Name': 'fab_waste.brand.print_name',
            'DataField': 'fab_waste.brand.print_name'
          }, { 'Name': 'fab_waste.style.id', 'DataField': 'fab_waste.style.id' }, {
            'Name': 'fab_waste.style.code',
            'DataField': 'fab_waste.style.code'
          }, {
            'Name': 'fab_waste.style.name',
            'DataField': 'fab_waste.style.name'
          }, { 'Name': 'fab_waste.style.p_name', 'DataField': 'fab_waste.style.p_name' }, {
            'Name': 'fab_waste.unit.id',
            'DataField': 'fab_waste.unit.id'
          }, { 'Name': 'fab_waste.unit.code', 'DataField': 'fab_waste.unit.code' }, {
            'Name': 'fab_waste.unit.name',
            'DataField': 'fab_waste.unit.name'
          }, { 'Name': 'fab_waste.unit.digits', 'DataField': 'fab_waste.unit.digits' }, {
            'Name': 'fab_waste.rate',
            'DataField': 'fab_waste.rate'
          }, { 'Name': 'fab_waste.min_qty', 'DataField': 'fab_waste.min_qty' }, {
            'Name': 'fab_waste.max_qty',
            'DataField': 'fab_waste.max_qty'
          }, { 'Name': 'fab_waste.wgt', 'DataField': 'fab_waste.wgt' }, {
            'Name': 'fab_waste_wgt',
            'DataField': 'fab_waste_wgt'
          }, { 'Name': 'defects_count', 'DataField': 'defects_count' }, { 'Name': 'remarks', 'DataField': 'remarks' }],
          'Query': { 'DataSourceName': 'DataSource', 'CommandType': 'Text', 'CommandText': 'jpath=$', 'Timeout': 0 },
          'CaseSensitivity': 'Auto',
          'Collation': '',
          'KanatypeSensitivity': 'Auto',
          'AccentSensitivity': 'Auto',
          'WidthSensitivity': 'Auto'
        }]
      }
      // report = {"Name":"Report","Type":"report","Width":"1.5in","CustomProperties":[{"Name":"DisplayType","Value":"Page"},{"Name":"SizeType","Value":"Default"}],"Page":{"BottomMargin":"0in","LeftMargin":"0in","PageHeight":"3in","PageWidth":"1.5in","PageOrientation":"Portrait","RightMargin":"0in","TopMargin":"0in","ColumnSpacing":"0in","Columns":1},"Layers":[{"Type":"layer","Name":"default"}],"Body":{"Type":"section","Height":"2.75in","Name":"Body","ReportItems":[{"KeepTogether":true,"Type":"textbox","Top":"0.25cm","Left":"0.71in","Width":"0.79in","Height":"0.635cm","CanGrow":true,"Value":"=Fields.Item(\"machine.p_name\").Value","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt","FontWeight":"SemiBold"},"Name":"TextBox1"},{"ZIndex":2,"KeepTogether":true,"Type":"textbox","Top":"0.4271in","Left":"0.0312in","Width":"1.4688in","Height":"0.3333in","CanGrow":true,"Value":"=Fields!code.Value","Style":{"TextAlign":"Center","VerticalAlign":"Middle","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt","FontSize":"20pt","FontWeight":"ExtraBold"},"Name":"TextBox3"},{"ZIndex":3,"Type":"barcode","Top":"0.8125in","Left":"0.35in","Width":"0.8729in","Height":"0.8333in","Style":{"FontFamily":"Courier New","FontSize":"8pt"},"Symbology":"QRCode","Value":"=Fields!code.Value","Name":"Barcode1"},{"ZIndex":4,"Type":"inputfield","Top":"1.75in","Width":"0.5in","Height":"0.25in","Value":"Quality","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"InputField1"},{"ZIndex":5,"Type":"inputfield","Top":"2in","Width":"0.5in","Height":"0.25in","Value":"Color","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"InputField2"},{"ZIndex":6,"Type":"inputfield","Top":"2.25in","Width":"0.5in","Height":"0.25in","Value":"Weight","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"InputField3"},{"ZIndex":7,"Type":"inputfield","Top":"2.5in","Width":"0.5in","Height":"0.25in","Value":"Date","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"InputField4"},{"ZIndex":12,"Type":"inputfield","Top":"0.25cm","Left":"0cm","Width":"1.778cm","Height":"0.635cm","Value":"Machine","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt"},"Name":"InputField9"},{"ZIndex":13,"KeepTogether":true,"Type":"textbox","Top":"1.75in","Left":"0.51in","Width":"0.99in","Height":"0.25in","CanGrow":true,"Value":"=Fields.Item(\"fabric.quality.p_name\").Value","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt","FontWeight":"SemiBold","WrapMode":"NoWrap"},"Name":"TextBox2"},{"ZIndex":14,"KeepTogether":true,"Type":"textbox","Top":"2in","Left":"0.51in","Width":"0.99in","Height":"0.25in","CanGrow":true,"Value":"=Fields.Item(\"fabric.color.p_name\").Value","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt","FontWeight":"SemiBold","WrapMode":"NoWrap"},"Name":"TextBox4"},{"ZIndex":15,"KeepTogether":true,"Type":"textbox","Top":"2.25in","Left":"0.51in","Width":"0.99in","Height":"0.25in","CanGrow":true,"Value":"=Fields!fab_wgt.Value","Style":{"TextAlign":"Left","Format":"n3","PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt","FontWeight":"SemiBold"},"Name":"TextBox5"},{"ZIndex":16,"KeepTogether":true,"Type":"textbox","Top":"2.5in","Left":"0.51in","Width":"0.99in","Height":"0.25in","CanGrow":true,"Value":"=Fields!date.Value","Style":{"PaddingLeft":"2pt","PaddingRight":"2pt","PaddingTop":"2pt","PaddingBottom":"2pt","Format":"d","FontWeight":"SemiBold"},"Name":"TextBox6"}]},"DataSources":[{"Name":"DataSource","Transaction":false,"DataSourceReference":"","ConnectionProperties":{"DataProvider":"JSONEMBED","ConnectString":"jsondata={\\r\\n  \"id\": \"\",\\r\\n  \"code\": 0,\\r\\n  \"status\": 0,\\r\\n  \"type\": 0,\\r\\n  \"is_cr\": \"\",\\r\\n  \"finyear\": 2020,\\r\\n  \"doc_no\": 0,\\r\\n  \"machine\": {\\r\\n    \"id\": \"\",\\r\\n    \"code\": 0,\\r\\n    \"type\": 0,\\r\\n    \"nature\": 0,\\r\\n    \"name\": \"\",\\r\\n    \"p_name\": \"A40\"\\r\\n  },\\r\\n  \"shift\": {\\r\\n    \"id\": \"\",\\r\\n    \"code\": 0,\\r\\n    \"type\": 0,\\r\\n    \"name\": \"\"\\r\\n  },\\r\\n  \"operator\": {\\r\\n    \"id\": \"\",\\r\\n    \"code\": 0,\\r\\n    \"status\": 0,\\r\\n    \"emp_code\": \"\",\\r\\n    \"name\": \"\",\\r\\n    \"designation\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"min_wage\": 0\\r\\n    }\\r\\n  },\\r\\n  \"date\": \"0001-01-01\",\\r\\n  \"color\": {\\r\\n    \"id\": \"\",\\r\\n    \"code\": 0,\\r\\n    \"status\": 0,\\r\\n    \"name\": \"Light Green\",\\r\\n    \"p_name\": \"Light Green\",\\r\\n    \"wgt\": 0,\\r\\n    \"chart\": []\\r\\n  },\\r\\n  \"quality\": {\\r\\n    \"id\": \"\",\\r\\n    \"code\": 0,\\r\\n    \"name\": \"Madhu\",\\r\\n    \"p_name\": \"Madhu\",\\r\\n    \"colors_wgt\": []\\r\\n  },\\r\\n  \"fabric\": {\\r\\n    \"id\": \"\",\\r\\n    \"code\": 0,\\r\\n    \"nature\": 0,\\r\\n    \"ledger_group\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"status\": 0,\\r\\n      \"type\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"alias\": \"\",\\r\\n      \"print_name\": \"\",\\r\\n      \"parent_code\": 0,\\r\\n      \"nature\": 0,\\r\\n      \"affect_profit\": false,\\r\\n      \"behave_like_sub_ledger\": false,\\r\\n      \"net_cr_dr_balance\": false,\\r\\n      \"used_for_calculation\": false,\\r\\n      \"system_object\": false\\r\\n    },\\r\\n    \"name\": \"\",\\r\\n    \"p_name\": \"\",\\r\\n    \"process\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"nature\": 0,\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"group\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"type\": 0,\\r\\n      \"nature\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\",\\r\\n      \"hsn\": \"\",\\r\\n      \"gstrate\": 0,\\r\\n      \"itcrate\": 0,\\r\\n      \"unit\": {\\r\\n        \"id\": \"\",\\r\\n        \"code\": 0,\\r\\n        \"name\": \"\",\\r\\n        \"digits\": 0\\r\\n      },\\r\\n      \"subunit\": {\\r\\n        \"id\": \"\",\\r\\n        \"code\": 0,\\r\\n        \"name\": \"\",\\r\\n        \"digits\": 0\\r\\n      },\\r\\n      \"conv_fact\": 0,\\r\\n      \"has_bom\": false,\\r\\n      \"sysobj\": false\\r\\n    },\\r\\n    \"design\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"color\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"status\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"quality\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"category\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"brand\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"print_name\": \"\"\\r\\n    },\\r\\n    \"style\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"unit\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"digits\": 0\\r\\n    },\\r\\n    \"rate\": 0,\\r\\n    \"min_qty\": 0,\\r\\n    \"max_qty\": 0,\\r\\n    \"wgt\": 0\\r\\n  },\\r\\n  \"fab_wgt\": 25,\\r\\n  \"yarn_waste\": {\\r\\n    \"id\": \"\",\\r\\n    \"code\": 0,\\r\\n    \"nature\": 0,\\r\\n    \"ledger_group\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"status\": 0,\\r\\n      \"type\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"alias\": \"\",\\r\\n      \"print_name\": \"\",\\r\\n      \"parent_code\": 0,\\r\\n      \"nature\": 0,\\r\\n      \"affect_profit\": false,\\r\\n      \"behave_like_sub_ledger\": false,\\r\\n      \"net_cr_dr_balance\": false,\\r\\n      \"used_for_calculation\": false,\\r\\n      \"system_object\": false\\r\\n    },\\r\\n    \"name\": \"\",\\r\\n    \"p_name\": \"\",\\r\\n    \"process\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"nature\": 0,\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"group\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"type\": 0,\\r\\n      \"nature\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\",\\r\\n      \"hsn\": \"\",\\r\\n      \"gstrate\": 0,\\r\\n      \"itcrate\": 0,\\r\\n      \"unit\": {\\r\\n        \"id\": \"\",\\r\\n        \"code\": 0,\\r\\n        \"name\": \"\",\\r\\n        \"digits\": 0\\r\\n      },\\r\\n      \"subunit\": {\\r\\n        \"id\": \"\",\\r\\n        \"code\": 0,\\r\\n        \"name\": \"\",\\r\\n        \"digits\": 0\\r\\n      },\\r\\n      \"conv_fact\": 0,\\r\\n      \"has_bom\": false,\\r\\n      \"sysobj\": false\\r\\n    },\\r\\n    \"design\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"color\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"status\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"quality\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"category\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"brand\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"print_name\": \"\"\\r\\n    },\\r\\n    \"style\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"unit\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"digits\": 0\\r\\n    },\\r\\n    \"rate\": 0,\\r\\n    \"min_qty\": 0,\\r\\n    \"max_qty\": 0,\\r\\n    \"wgt\": 0\\r\\n  },\\r\\n  \"yarn_waste_wgt\": 0,\\r\\n  \"fab_waste\": {\\r\\n    \"id\": \"\",\\r\\n    \"code\": 0,\\r\\n    \"nature\": 0,\\r\\n    \"ledger_group\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"status\": 0,\\r\\n      \"type\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"alias\": \"\",\\r\\n      \"print_name\": \"\",\\r\\n      \"parent_code\": 0,\\r\\n      \"nature\": 0,\\r\\n      \"affect_profit\": false,\\r\\n      \"behave_like_sub_ledger\": false,\\r\\n      \"net_cr_dr_balance\": false,\\r\\n      \"used_for_calculation\": false,\\r\\n      \"system_object\": false\\r\\n    },\\r\\n    \"name\": \"\",\\r\\n    \"p_name\": \"\",\\r\\n    \"process\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"nature\": 0,\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"group\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"type\": 0,\\r\\n      \"nature\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\",\\r\\n      \"hsn\": \"\",\\r\\n      \"gstrate\": 0,\\r\\n      \"itcrate\": 0,\\r\\n      \"unit\": {\\r\\n        \"id\": \"\",\\r\\n        \"code\": 0,\\r\\n        \"name\": \"\",\\r\\n        \"digits\": 0\\r\\n      },\\r\\n      \"subunit\": {\\r\\n        \"id\": \"\",\\r\\n        \"code\": 0,\\r\\n        \"name\": \"\",\\r\\n        \"digits\": 0\\r\\n      },\\r\\n      \"conv_fact\": 0,\\r\\n      \"has_bom\": false,\\r\\n      \"sysobj\": false\\r\\n    },\\r\\n    \"design\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"color\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"status\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"quality\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"category\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"brand\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"print_name\": \"\"\\r\\n    },\\r\\n    \"style\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"p_name\": \"\"\\r\\n    },\\r\\n    \"unit\": {\\r\\n      \"id\": \"\",\\r\\n      \"code\": 0,\\r\\n      \"name\": \"\",\\r\\n      \"digits\": 0\\r\\n    },\\r\\n    \"rate\": 0,\\r\\n    \"min_qty\": 0,\\r\\n    \"max_qty\": 0,\\r\\n    \"wgt\": 0\\r\\n  },\\r\\n  \"fab_waste_wgt\": 0,\\r\\n  \"defects_count\": 0,\\r\\n  \"remarks\": \"\"\\r\\n}","IntegratedSecurity":false,"Prompt":"","Collation":"","AccentSensivity":"Auto","WidthSensivity":"Auto"}}],"DataSets":[{"Name":"DataSet","Fields":[{"Name":"id","DataField":"id"},{"Name":"code","DataField":"code"},{"Name":"status","DataField":"status"},{"Name":"type","DataField":"type"},{"Name":"is_cr","DataField":"is_cr"},{"Name":"finyear","DataField":"finyear"},{"Name":"doc_no","DataField":"doc_no"},{"Name":"machine.id","DataField":"machine.id"},{"Name":"machine.code","DataField":"machine.code"},{"Name":"machine.type","DataField":"machine.type"},{"Name":"machine.nature","DataField":"machine.nature"},{"Name":"machine.name","DataField":"machine.name"},{"Name":"machine.p_name","DataField":"machine.p_name"},{"Name":"shift.id","DataField":"shift.id"},{"Name":"shift.code","DataField":"shift.code"},{"Name":"shift.type","DataField":"shift.type"},{"Name":"shift.name","DataField":"shift.name"},{"Name":"operator.id","DataField":"operator.id"},{"Name":"operator.code","DataField":"operator.code"},{"Name":"operator.status","DataField":"operator.status"},{"Name":"operator.emp_code","DataField":"operator.emp_code"},{"Name":"operator.name","DataField":"operator.name"},{"Name":"operator.designation.id","DataField":"operator.designation.id"},{"Name":"operator.designation.code","DataField":"operator.designation.code"},{"Name":"operator.designation.name","DataField":"operator.designation.name"},{"Name":"operator.designation.min_wage","DataField":"operator.designation.min_wage"},{"Name":"date","DataField":"date"},{"Name":"color.id","DataField":"color.id"},{"Name":"color.code","DataField":"color.code"},{"Name":"color.status","DataField":"color.status"},{"Name":"color.name","DataField":"color.name"},{"Name":"color.p_name","DataField":"color.p_name"},{"Name":"color.wgt","DataField":"color.wgt"},{"Name":"color.chart","DataField":"color.chart"},{"Name":"quality.id","DataField":"quality.id"},{"Name":"quality.code","DataField":"quality.code"},{"Name":"quality.name","DataField":"quality.name"},{"Name":"quality.p_name","DataField":"quality.p_name"},{"Name":"quality.colors_wgt","DataField":"quality.colors_wgt"},{"Name":"fabric.id","DataField":"fabric.id"},{"Name":"fabric.code","DataField":"fabric.code"},{"Name":"fabric.nature","DataField":"fabric.nature"},{"Name":"fabric.ledger_group.id","DataField":"fabric.ledger_group.id"},{"Name":"fabric.ledger_group.code","DataField":"fabric.ledger_group.code"},{"Name":"fabric.ledger_group.status","DataField":"fabric.ledger_group.status"},{"Name":"fabric.ledger_group.type","DataField":"fabric.ledger_group.type"},{"Name":"fabric.ledger_group.name","DataField":"fabric.ledger_group.name"},{"Name":"fabric.ledger_group.alias","DataField":"fabric.ledger_group.alias"},{"Name":"fabric.ledger_group.print_name","DataField":"fabric.ledger_group.print_name"},{"Name":"fabric.ledger_group.parent_code","DataField":"fabric.ledger_group.parent_code"},{"Name":"fabric.ledger_group.nature","DataField":"fabric.ledger_group.nature"},{"Name":"fabric.ledger_group.affect_profit","DataField":"fabric.ledger_group.affect_profit"},{"Name":"fabric.ledger_group.behave_like_sub_ledger","DataField":"fabric.ledger_group.behave_like_sub_ledger"},{"Name":"fabric.ledger_group.net_cr_dr_balance","DataField":"fabric.ledger_group.net_cr_dr_balance"},{"Name":"fabric.ledger_group.used_for_calculation","DataField":"fabric.ledger_group.used_for_calculation"},{"Name":"fabric.ledger_group.system_object","DataField":"fabric.ledger_group.system_object"},{"Name":"fabric.name","DataField":"fabric.name"},{"Name":"fabric.p_name","DataField":"fabric.p_name"},{"Name":"fabric.process.id","DataField":"fabric.process.id"},{"Name":"fabric.process.code","DataField":"fabric.process.code"},{"Name":"fabric.process.name","DataField":"fabric.process.name"},{"Name":"fabric.process.nature","DataField":"fabric.process.nature"},{"Name":"fabric.process.p_name","DataField":"fabric.process.p_name"},{"Name":"fabric.group.id","DataField":"fabric.group.id"},{"Name":"fabric.group.code","DataField":"fabric.group.code"},{"Name":"fabric.group.type","DataField":"fabric.group.type"},{"Name":"fabric.group.nature","DataField":"fabric.group.nature"},{"Name":"fabric.group.name","DataField":"fabric.group.name"},{"Name":"fabric.group.p_name","DataField":"fabric.group.p_name"},{"Name":"fabric.group.hsn","DataField":"fabric.group.hsn"},{"Name":"fabric.group.gstrate","DataField":"fabric.group.gstrate"},{"Name":"fabric.group.itcrate","DataField":"fabric.group.itcrate"},{"Name":"fabric.group.unit.id","DataField":"fabric.group.unit.id"},{"Name":"fabric.group.unit.code","DataField":"fabric.group.unit.code"},{"Name":"fabric.group.unit.name","DataField":"fabric.group.unit.name"},{"Name":"fabric.group.unit.digits","DataField":"fabric.group.unit.digits"},{"Name":"fabric.group.subunit.id","DataField":"fabric.group.subunit.id"},{"Name":"fabric.group.subunit.code","DataField":"fabric.group.subunit.code"},{"Name":"fabric.group.subunit.name","DataField":"fabric.group.subunit.name"},{"Name":"fabric.group.subunit.digits","DataField":"fabric.group.subunit.digits"},{"Name":"fabric.group.conv_fact","DataField":"fabric.group.conv_fact"},{"Name":"fabric.group.has_bom","DataField":"fabric.group.has_bom"},{"Name":"fabric.group.sysobj","DataField":"fabric.group.sysobj"},{"Name":"fabric.design.id","DataField":"fabric.design.id"},{"Name":"fabric.design.code","DataField":"fabric.design.code"},{"Name":"fabric.design.name","DataField":"fabric.design.name"},{"Name":"fabric.design.p_name","DataField":"fabric.design.p_name"},{"Name":"fabric.color.id","DataField":"fabric.color.id"},{"Name":"fabric.color.code","DataField":"fabric.color.code"},{"Name":"fabric.color.status","DataField":"fabric.color.status"},{"Name":"fabric.color.name","DataField":"fabric.color.name"},{"Name":"fabric.color.p_name","DataField":"fabric.color.p_name"},{"Name":"fabric.quality.id","DataField":"fabric.quality.id"},{"Name":"fabric.quality.code","DataField":"fabric.quality.code"},{"Name":"fabric.quality.name","DataField":"fabric.quality.name"},{"Name":"fabric.quality.p_name","DataField":"fabric.quality.p_name"},{"Name":"fabric.category.id","DataField":"fabric.category.id"},{"Name":"fabric.category.code","DataField":"fabric.category.code"},{"Name":"fabric.category.name","DataField":"fabric.category.name"},{"Name":"fabric.category.p_name","DataField":"fabric.category.p_name"},{"Name":"fabric.brand.id","DataField":"fabric.brand.id"},{"Name":"fabric.brand.code","DataField":"fabric.brand.code"},{"Name":"fabric.brand.name","DataField":"fabric.brand.name"},{"Name":"fabric.brand.print_name","DataField":"fabric.brand.print_name"},{"Name":"fabric.style.id","DataField":"fabric.style.id"},{"Name":"fabric.style.code","DataField":"fabric.style.code"},{"Name":"fabric.style.name","DataField":"fabric.style.name"},{"Name":"fabric.style.p_name","DataField":"fabric.style.p_name"},{"Name":"fabric.unit.id","DataField":"fabric.unit.id"},{"Name":"fabric.unit.code","DataField":"fabric.unit.code"},{"Name":"fabric.unit.name","DataField":"fabric.unit.name"},{"Name":"fabric.unit.digits","DataField":"fabric.unit.digits"},{"Name":"fabric.rate","DataField":"fabric.rate"},{"Name":"fabric.min_qty","DataField":"fabric.min_qty"},{"Name":"fabric.max_qty","DataField":"fabric.max_qty"},{"Name":"fabric.wgt","DataField":"fabric.wgt"},{"Name":"fab_wgt","DataField":"fab_wgt"},{"Name":"yarn_waste.id","DataField":"yarn_waste.id"},{"Name":"yarn_waste.code","DataField":"yarn_waste.code"},{"Name":"yarn_waste.nature","DataField":"yarn_waste.nature"},{"Name":"yarn_waste.ledger_group.id","DataField":"yarn_waste.ledger_group.id"},{"Name":"yarn_waste.ledger_group.code","DataField":"yarn_waste.ledger_group.code"},{"Name":"yarn_waste.ledger_group.status","DataField":"yarn_waste.ledger_group.status"},{"Name":"yarn_waste.ledger_group.type","DataField":"yarn_waste.ledger_group.type"},{"Name":"yarn_waste.ledger_group.name","DataField":"yarn_waste.ledger_group.name"},{"Name":"yarn_waste.ledger_group.alias","DataField":"yarn_waste.ledger_group.alias"},{"Name":"yarn_waste.ledger_group.print_name","DataField":"yarn_waste.ledger_group.print_name"},{"Name":"yarn_waste.ledger_group.parent_code","DataField":"yarn_waste.ledger_group.parent_code"},{"Name":"yarn_waste.ledger_group.nature","DataField":"yarn_waste.ledger_group.nature"},{"Name":"yarn_waste.ledger_group.affect_profit","DataField":"yarn_waste.ledger_group.affect_profit"},{"Name":"yarn_waste.ledger_group.behave_like_sub_ledger","DataField":"yarn_waste.ledger_group.behave_like_sub_ledger"},{"Name":"yarn_waste.ledger_group.net_cr_dr_balance","DataField":"yarn_waste.ledger_group.net_cr_dr_balance"},{"Name":"yarn_waste.ledger_group.used_for_calculation","DataField":"yarn_waste.ledger_group.used_for_calculation"},{"Name":"yarn_waste.ledger_group.system_object","DataField":"yarn_waste.ledger_group.system_object"},{"Name":"yarn_waste.name","DataField":"yarn_waste.name"},{"Name":"yarn_waste.p_name","DataField":"yarn_waste.p_name"},{"Name":"yarn_waste.process.id","DataField":"yarn_waste.process.id"},{"Name":"yarn_waste.process.code","DataField":"yarn_waste.process.code"},{"Name":"yarn_waste.process.name","DataField":"yarn_waste.process.name"},{"Name":"yarn_waste.process.nature","DataField":"yarn_waste.process.nature"},{"Name":"yarn_waste.process.p_name","DataField":"yarn_waste.process.p_name"},{"Name":"yarn_waste.group.id","DataField":"yarn_waste.group.id"},{"Name":"yarn_waste.group.code","DataField":"yarn_waste.group.code"},{"Name":"yarn_waste.group.type","DataField":"yarn_waste.group.type"},{"Name":"yarn_waste.group.nature","DataField":"yarn_waste.group.nature"},{"Name":"yarn_waste.group.name","DataField":"yarn_waste.group.name"},{"Name":"yarn_waste.group.p_name","DataField":"yarn_waste.group.p_name"},{"Name":"yarn_waste.group.hsn","DataField":"yarn_waste.group.hsn"},{"Name":"yarn_waste.group.gstrate","DataField":"yarn_waste.group.gstrate"},{"Name":"yarn_waste.group.itcrate","DataField":"yarn_waste.group.itcrate"},{"Name":"yarn_waste.group.unit.id","DataField":"yarn_waste.group.unit.id"},{"Name":"yarn_waste.group.unit.code","DataField":"yarn_waste.group.unit.code"},{"Name":"yarn_waste.group.unit.name","DataField":"yarn_waste.group.unit.name"},{"Name":"yarn_waste.group.unit.digits","DataField":"yarn_waste.group.unit.digits"},{"Name":"yarn_waste.group.subunit.id","DataField":"yarn_waste.group.subunit.id"},{"Name":"yarn_waste.group.subunit.code","DataField":"yarn_waste.group.subunit.code"},{"Name":"yarn_waste.group.subunit.name","DataField":"yarn_waste.group.subunit.name"},{"Name":"yarn_waste.group.subunit.digits","DataField":"yarn_waste.group.subunit.digits"},{"Name":"yarn_waste.group.conv_fact","DataField":"yarn_waste.group.conv_fact"},{"Name":"yarn_waste.group.has_bom","DataField":"yarn_waste.group.has_bom"},{"Name":"yarn_waste.group.sysobj","DataField":"yarn_waste.group.sysobj"},{"Name":"yarn_waste.design.id","DataField":"yarn_waste.design.id"},{"Name":"yarn_waste.design.code","DataField":"yarn_waste.design.code"},{"Name":"yarn_waste.design.name","DataField":"yarn_waste.design.name"},{"Name":"yarn_waste.design.p_name","DataField":"yarn_waste.design.p_name"},{"Name":"yarn_waste.color.id","DataField":"yarn_waste.color.id"},{"Name":"yarn_waste.color.code","DataField":"yarn_waste.color.code"},{"Name":"yarn_waste.color.status","DataField":"yarn_waste.color.status"},{"Name":"yarn_waste.color.name","DataField":"yarn_waste.color.name"},{"Name":"yarn_waste.color.p_name","DataField":"yarn_waste.color.p_name"},{"Name":"yarn_waste.quality.id","DataField":"yarn_waste.quality.id"},{"Name":"yarn_waste.quality.code","DataField":"yarn_waste.quality.code"},{"Name":"yarn_waste.quality.name","DataField":"yarn_waste.quality.name"},{"Name":"yarn_waste.quality.p_name","DataField":"yarn_waste.quality.p_name"},{"Name":"yarn_waste.category.id","DataField":"yarn_waste.category.id"},{"Name":"yarn_waste.category.code","DataField":"yarn_waste.category.code"},{"Name":"yarn_waste.category.name","DataField":"yarn_waste.category.name"},{"Name":"yarn_waste.category.p_name","DataField":"yarn_waste.category.p_name"},{"Name":"yarn_waste.brand.id","DataField":"yarn_waste.brand.id"},{"Name":"yarn_waste.brand.code","DataField":"yarn_waste.brand.code"},{"Name":"yarn_waste.brand.name","DataField":"yarn_waste.brand.name"},{"Name":"yarn_waste.brand.print_name","DataField":"yarn_waste.brand.print_name"},{"Name":"yarn_waste.style.id","DataField":"yarn_waste.style.id"},{"Name":"yarn_waste.style.code","DataField":"yarn_waste.style.code"},{"Name":"yarn_waste.style.name","DataField":"yarn_waste.style.name"},{"Name":"yarn_waste.style.p_name","DataField":"yarn_waste.style.p_name"},{"Name":"yarn_waste.unit.id","DataField":"yarn_waste.unit.id"},{"Name":"yarn_waste.unit.code","DataField":"yarn_waste.unit.code"},{"Name":"yarn_waste.unit.name","DataField":"yarn_waste.unit.name"},{"Name":"yarn_waste.unit.digits","DataField":"yarn_waste.unit.digits"},{"Name":"yarn_waste.rate","DataField":"yarn_waste.rate"},{"Name":"yarn_waste.min_qty","DataField":"yarn_waste.min_qty"},{"Name":"yarn_waste.max_qty","DataField":"yarn_waste.max_qty"},{"Name":"yarn_waste.wgt","DataField":"yarn_waste.wgt"},{"Name":"yarn_waste_wgt","DataField":"yarn_waste_wgt"},{"Name":"fab_waste.id","DataField":"fab_waste.id"},{"Name":"fab_waste.code","DataField":"fab_waste.code"},{"Name":"fab_waste.nature","DataField":"fab_waste.nature"},{"Name":"fab_waste.ledger_group.id","DataField":"fab_waste.ledger_group.id"},{"Name":"fab_waste.ledger_group.code","DataField":"fab_waste.ledger_group.code"},{"Name":"fab_waste.ledger_group.status","DataField":"fab_waste.ledger_group.status"},{"Name":"fab_waste.ledger_group.type","DataField":"fab_waste.ledger_group.type"},{"Name":"fab_waste.ledger_group.name","DataField":"fab_waste.ledger_group.name"},{"Name":"fab_waste.ledger_group.alias","DataField":"fab_waste.ledger_group.alias"},{"Name":"fab_waste.ledger_group.print_name","DataField":"fab_waste.ledger_group.print_name"},{"Name":"fab_waste.ledger_group.parent_code","DataField":"fab_waste.ledger_group.parent_code"},{"Name":"fab_waste.ledger_group.nature","DataField":"fab_waste.ledger_group.nature"},{"Name":"fab_waste.ledger_group.affect_profit","DataField":"fab_waste.ledger_group.affect_profit"},{"Name":"fab_waste.ledger_group.behave_like_sub_ledger","DataField":"fab_waste.ledger_group.behave_like_sub_ledger"},{"Name":"fab_waste.ledger_group.net_cr_dr_balance","DataField":"fab_waste.ledger_group.net_cr_dr_balance"},{"Name":"fab_waste.ledger_group.used_for_calculation","DataField":"fab_waste.ledger_group.used_for_calculation"},{"Name":"fab_waste.ledger_group.system_object","DataField":"fab_waste.ledger_group.system_object"},{"Name":"fab_waste.name","DataField":"fab_waste.name"},{"Name":"fab_waste.p_name","DataField":"fab_waste.p_name"},{"Name":"fab_waste.process.id","DataField":"fab_waste.process.id"},{"Name":"fab_waste.process.code","DataField":"fab_waste.process.code"},{"Name":"fab_waste.process.name","DataField":"fab_waste.process.name"},{"Name":"fab_waste.process.nature","DataField":"fab_waste.process.nature"},{"Name":"fab_waste.process.p_name","DataField":"fab_waste.process.p_name"},{"Name":"fab_waste.group.id","DataField":"fab_waste.group.id"},{"Name":"fab_waste.group.code","DataField":"fab_waste.group.code"},{"Name":"fab_waste.group.type","DataField":"fab_waste.group.type"},{"Name":"fab_waste.group.nature","DataField":"fab_waste.group.nature"},{"Name":"fab_waste.group.name","DataField":"fab_waste.group.name"},{"Name":"fab_waste.group.p_name","DataField":"fab_waste.group.p_name"},{"Name":"fab_waste.group.hsn","DataField":"fab_waste.group.hsn"},{"Name":"fab_waste.group.gstrate","DataField":"fab_waste.group.gstrate"},{"Name":"fab_waste.group.itcrate","DataField":"fab_waste.group.itcrate"},{"Name":"fab_waste.group.unit.id","DataField":"fab_waste.group.unit.id"},{"Name":"fab_waste.group.unit.code","DataField":"fab_waste.group.unit.code"},{"Name":"fab_waste.group.unit.name","DataField":"fab_waste.group.unit.name"},{"Name":"fab_waste.group.unit.digits","DataField":"fab_waste.group.unit.digits"},{"Name":"fab_waste.group.subunit.id","DataField":"fab_waste.group.subunit.id"},{"Name":"fab_waste.group.subunit.code","DataField":"fab_waste.group.subunit.code"},{"Name":"fab_waste.group.subunit.name","DataField":"fab_waste.group.subunit.name"},{"Name":"fab_waste.group.subunit.digits","DataField":"fab_waste.group.subunit.digits"},{"Name":"fab_waste.group.conv_fact","DataField":"fab_waste.group.conv_fact"},{"Name":"fab_waste.group.has_bom","DataField":"fab_waste.group.has_bom"},{"Name":"fab_waste.group.sysobj","DataField":"fab_waste.group.sysobj"},{"Name":"fab_waste.design.id","DataField":"fab_waste.design.id"},{"Name":"fab_waste.design.code","DataField":"fab_waste.design.code"},{"Name":"fab_waste.design.name","DataField":"fab_waste.design.name"},{"Name":"fab_waste.design.p_name","DataField":"fab_waste.design.p_name"},{"Name":"fab_waste.color.id","DataField":"fab_waste.color.id"},{"Name":"fab_waste.color.code","DataField":"fab_waste.color.code"},{"Name":"fab_waste.color.status","DataField":"fab_waste.color.status"},{"Name":"fab_waste.color.name","DataField":"fab_waste.color.name"},{"Name":"fab_waste.color.p_name","DataField":"fab_waste.color.p_name"},{"Name":"fab_waste.quality.id","DataField":"fab_waste.quality.id"},{"Name":"fab_waste.quality.code","DataField":"fab_waste.quality.code"},{"Name":"fab_waste.quality.name","DataField":"fab_waste.quality.name"},{"Name":"fab_waste.quality.p_name","DataField":"fab_waste.quality.p_name"},{"Name":"fab_waste.category.id","DataField":"fab_waste.category.id"},{"Name":"fab_waste.category.code","DataField":"fab_waste.category.code"},{"Name":"fab_waste.category.name","DataField":"fab_waste.category.name"},{"Name":"fab_waste.category.p_name","DataField":"fab_waste.category.p_name"},{"Name":"fab_waste.brand.id","DataField":"fab_waste.brand.id"},{"Name":"fab_waste.brand.code","DataField":"fab_waste.brand.code"},{"Name":"fab_waste.brand.name","DataField":"fab_waste.brand.name"},{"Name":"fab_waste.brand.print_name","DataField":"fab_waste.brand.print_name"},{"Name":"fab_waste.style.id","DataField":"fab_waste.style.id"},{"Name":"fab_waste.style.code","DataField":"fab_waste.style.code"},{"Name":"fab_waste.style.name","DataField":"fab_waste.style.name"},{"Name":"fab_waste.style.p_name","DataField":"fab_waste.style.p_name"},{"Name":"fab_waste.unit.id","DataField":"fab_waste.unit.id"},{"Name":"fab_waste.unit.code","DataField":"fab_waste.unit.code"},{"Name":"fab_waste.unit.name","DataField":"fab_waste.unit.name"},{"Name":"fab_waste.unit.digits","DataField":"fab_waste.unit.digits"},{"Name":"fab_waste.rate","DataField":"fab_waste.rate"},{"Name":"fab_waste.min_qty","DataField":"fab_waste.min_qty"},{"Name":"fab_waste.max_qty","DataField":"fab_waste.max_qty"},{"Name":"fab_waste.wgt","DataField":"fab_waste.wgt"},{"Name":"fab_waste_wgt","DataField":"fab_waste_wgt"},{"Name":"defects_count","DataField":"defects_count"},{"Name":"remarks","DataField":"remarks"}],"Query":{"DataSourceName":"DataSource","CommandType":"Text","CommandText":"jpath=$","Timeout":0},"CaseSensitivity":"Auto","Collation":"","KanatypeSensitivity":"Auto","AccentSensitivity":"Auto","WidthSensitivity":"Auto"}],"DataElementName":"BarcodeLabel","DataElementStyle":"Auto"};
      report = {
        'Name': 'Report',
        'Type': 'report',
        'Width': '1.5in',
        'CustomProperties': [{ 'Name': 'DisplayType', 'Value': 'Page' }, { 'Name': 'SizeType', 'Value': 'Default' }],
        'Page': {
          'BottomMargin': '0in',
          'LeftMargin': '0in',
          'PageHeight': '3in',
          'PageWidth': '1.5in',
          'PageOrientation': 'Portrait',
          'RightMargin': '0in',
          'TopMargin': '0in',
          'ColumnSpacing': '0in',
          'Columns': 1
        },
        'Layers': [{ 'Type': 'layer', 'Name': 'default' }],
        'Body': {
          'Type': 'section',
          'Height': '2.75in',
          'Name': 'Body',
          'ReportItems': [{
            'KeepTogether': true,
            'Type': 'textbox',
            'Top': '0.25cm',
            'Left': '0.71in',
            'Width': '0.79in',
            'Height': '0.635cm',
            'CanGrow': true,
            'Value': '=Fields.Item("machine.p_name").Value',
            'Style': {
              'PaddingLeft': '2pt',
              'PaddingRight': '2pt',
              'PaddingTop': '2pt',
              'PaddingBottom': '2pt',
              'FontWeight': 'SemiBold'
            },
            'Name': 'TextBox1'
          }, {
            'ZIndex': 2,
            'KeepTogether': true,
            'Type': 'textbox',
            'Top': '0.4271in',
            'Left': '0.0312in',
            'Width': '1.4688in',
            'Height': '0.3333in',
            'CanGrow': true,
            'Value': '=Fields!code.Value',
            'Style': {
              'TextAlign': 'Center',
              'VerticalAlign': 'Middle',
              'PaddingLeft': '2pt',
              'PaddingRight': '2pt',
              'PaddingTop': '2pt',
              'PaddingBottom': '2pt',
              'FontSize': '20pt',
              'FontWeight': 'ExtraBold'
            },
            'Name': 'TextBox3'
          }, {
            'ZIndex': 3,
            'Type': 'barcode',
            'Top': '0.8125in',
            'Left': '0.35in',
            'Width': '0.8729in',
            'Height': '0.8333in',
            'Style': { 'FontFamily': 'Courier New', 'FontSize': '8pt' },
            'Symbology': 'QRCode',
            'Value': '=Fields!code.Value',
            'Name': 'Barcode1'
          }, {
            'ZIndex': 4,
            'Type': 'inputfield',
            'Top': '1.75in',
            'Width': '0.5in',
            'Height': '0.25in',
            'Value': 'Quality',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'InputField1'
          }, {
            'ZIndex': 5,
            'Type': 'inputfield',
            'Top': '2in',
            'Width': '0.5in',
            'Height': '0.25in',
            'Value': 'Color',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'InputField2'
          }, {
            'ZIndex': 6,
            'Type': 'inputfield',
            'Top': '2.25in',
            'Width': '0.5in',
            'Height': '0.25in',
            'Value': 'Weight',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'InputField3'
          }, {
            'ZIndex': 7,
            'Type': 'inputfield',
            'Top': '2.5in',
            'Width': '0.5in',
            'Height': '0.25in',
            'Value': 'Date',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'InputField4'
          }, {
            'ZIndex': 12,
            'Type': 'inputfield',
            'Top': '0.25cm',
            'Left': '0cm',
            'Width': '1.778cm',
            'Height': '0.635cm',
            'Value': 'Machine',
            'Style': { 'PaddingLeft': '2pt', 'PaddingRight': '2pt', 'PaddingTop': '2pt', 'PaddingBottom': '2pt' },
            'Name': 'InputField9'
          }, {
            'ZIndex': 13,
            'KeepTogether': true,
            'Type': 'textbox',
            'Top': '1.75in',
            'Left': '0.51in',
            'Width': '0.99in',
            'Height': '0.25in',
            'CanGrow': true,
            'Value': '=Fields.Item("fabric.quality.p_name").Value',
            'Style': {
              'PaddingLeft': '2pt',
              'PaddingRight': '2pt',
              'PaddingTop': '2pt',
              'PaddingBottom': '2pt',
              'FontWeight': 'SemiBold',
              'WrapMode': 'NoWrap'
            },
            'Name': 'TextBox2'
          }, {
            'ZIndex': 14,
            'KeepTogether': true,
            'Type': 'textbox',
            'Top': '2in',
            'Left': '0.51in',
            'Width': '0.99in',
            'Height': '0.25in',
            'CanGrow': true,
            'Value': '=Fields.Item("fabric.color.p_name").Value',
            'Style': {
              'PaddingLeft': '2pt',
              'PaddingRight': '2pt',
              'PaddingTop': '2pt',
              'PaddingBottom': '2pt',
              'FontWeight': 'SemiBold',
              'WrapMode': 'NoWrap'
            },
            'Name': 'TextBox4'
          }, {
            'ZIndex': 15,
            'KeepTogether': true,
            'Type': 'textbox',
            'Top': '2.25in',
            'Left': '0.51in',
            'Width': '0.99in',
            'Height': '0.25in',
            'CanGrow': true,
            'Value': '=Fields!fab_wgt.Value',
            'Style': {
              'TextAlign': 'Left',
              'Format': 'n3',
              'PaddingLeft': '2pt',
              'PaddingRight': '2pt',
              'PaddingTop': '2pt',
              'PaddingBottom': '2pt',
              'FontWeight': 'SemiBold'
            },
            'Name': 'TextBox5'
          }, {
            'ZIndex': 16,
            'KeepTogether': true,
            'Type': 'textbox',
            'Top': '2.5in',
            'Left': '0.51in',
            'Width': '0.99in',
            'Height': '0.25in',
            'CanGrow': true,
            'Value': '=Fields!date.Value',
            'Style': {
              'PaddingLeft': '2pt',
              'PaddingRight': '2pt',
              'PaddingTop': '2pt',
              'PaddingBottom': '2pt',
              'Format': 'd',
              'FontWeight': 'SemiBold'
            },
            'Name': 'TextBox6'
          }]
        },
        'DataSources': [{
          'Name': 'DataSource', 'Transaction': false, 'DataSourceReference': '', 'ConnectionProperties': {
            'DataProvider': 'JSONEMBED',
            'ConnectString': 'jsondata={\\r\\n  "id": "",\\r\\n  "code": 0,\\r\\n  "status": 0,\\r\\n  "type": 0,\\r\\n  "is_cr": "",\\r\\n  "finyear": 2020,\\r\\n  "doc_no": 0,\\r\\n  "machine": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "type": 0,\\r\\n    "nature": 0,\\r\\n    "name": "",\\r\\n    "p_name": "A40"\\r\\n  },\\r\\n  "shift": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "type": 0,\\r\\n    "name": ""\\r\\n  },\\r\\n  "operator": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "status": 0,\\r\\n    "emp_code": "",\\r\\n    "name": "",\\r\\n    "designation": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "min_wage": 0\\r\\n    }\\r\\n  },\\r\\n  "date": "0001-01-01",\\r\\n  "color": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "status": 0,\\r\\n    "name": "Light Green",\\r\\n    "p_name": "Light Green",\\r\\n    "wgt": 0,\\r\\n    "chart": []\\r\\n  },\\r\\n  "quality": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "name": "Madhu",\\r\\n    "p_name": "Madhu",\\r\\n    "colors_wgt": []\\r\\n  },\\r\\n  "fabric": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "nature": 0,\\r\\n    "ledger_group": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "status": 0,\\r\\n      "type": 0,\\r\\n      "name": "",\\r\\n      "alias": "",\\r\\n      "print_name": "",\\r\\n      "parent_code": 0,\\r\\n      "nature": 0,\\r\\n      "affect_profit": false,\\r\\n      "behave_like_sub_ledger": false,\\r\\n      "net_cr_dr_balance": false,\\r\\n      "used_for_calculation": false,\\r\\n      "system_object": false\\r\\n    },\\r\\n    "name": "",\\r\\n    "p_name": "",\\r\\n    "process": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "nature": 0,\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "group": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "type": 0,\\r\\n      "nature": 0,\\r\\n      "name": "",\\r\\n      "p_name": "",\\r\\n      "hsn": "",\\r\\n      "gstrate": 0,\\r\\n      "itcrate": 0,\\r\\n      "unit": {\\r\\n        "id": "",\\r\\n        "code": 0,\\r\\n        "name": "",\\r\\n        "digits": 0\\r\\n      },\\r\\n      "subunit": {\\r\\n        "id": "",\\r\\n        "code": 0,\\r\\n        "name": "",\\r\\n        "digits": 0\\r\\n      },\\r\\n      "conv_fact": 0,\\r\\n      "has_bom": false,\\r\\n      "sysobj": false\\r\\n    },\\r\\n    "design": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "color": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "status": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "quality": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "category": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "brand": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "print_name": ""\\r\\n    },\\r\\n    "style": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "unit": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "digits": 0\\r\\n    },\\r\\n    "rate": 0,\\r\\n    "min_qty": 0,\\r\\n    "max_qty": 0,\\r\\n    "wgt": 0\\r\\n  },\\r\\n  "fab_wgt": 25,\\r\\n  "yarn_waste": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "nature": 0,\\r\\n    "ledger_group": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "status": 0,\\r\\n      "type": 0,\\r\\n      "name": "",\\r\\n      "alias": "",\\r\\n      "print_name": "",\\r\\n      "parent_code": 0,\\r\\n      "nature": 0,\\r\\n      "affect_profit": false,\\r\\n      "behave_like_sub_ledger": false,\\r\\n      "net_cr_dr_balance": false,\\r\\n      "used_for_calculation": false,\\r\\n      "system_object": false\\r\\n    },\\r\\n    "name": "",\\r\\n    "p_name": "",\\r\\n    "process": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "nature": 0,\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "group": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "type": 0,\\r\\n      "nature": 0,\\r\\n      "name": "",\\r\\n      "p_name": "",\\r\\n      "hsn": "",\\r\\n      "gstrate": 0,\\r\\n      "itcrate": 0,\\r\\n      "unit": {\\r\\n        "id": "",\\r\\n        "code": 0,\\r\\n        "name": "",\\r\\n        "digits": 0\\r\\n      },\\r\\n      "subunit": {\\r\\n        "id": "",\\r\\n        "code": 0,\\r\\n        "name": "",\\r\\n        "digits": 0\\r\\n      },\\r\\n      "conv_fact": 0,\\r\\n      "has_bom": false,\\r\\n      "sysobj": false\\r\\n    },\\r\\n    "design": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "color": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "status": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "quality": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "category": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "brand": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "print_name": ""\\r\\n    },\\r\\n    "style": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "unit": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "digits": 0\\r\\n    },\\r\\n    "rate": 0,\\r\\n    "min_qty": 0,\\r\\n    "max_qty": 0,\\r\\n    "wgt": 0\\r\\n  },\\r\\n  "yarn_waste_wgt": 0,\\r\\n  "fab_waste": {\\r\\n    "id": "",\\r\\n    "code": 0,\\r\\n    "nature": 0,\\r\\n    "ledger_group": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "status": 0,\\r\\n      "type": 0,\\r\\n      "name": "",\\r\\n      "alias": "",\\r\\n      "print_name": "",\\r\\n      "parent_code": 0,\\r\\n      "nature": 0,\\r\\n      "affect_profit": false,\\r\\n      "behave_like_sub_ledger": false,\\r\\n      "net_cr_dr_balance": false,\\r\\n      "used_for_calculation": false,\\r\\n      "system_object": false\\r\\n    },\\r\\n    "name": "",\\r\\n    "p_name": "",\\r\\n    "process": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "nature": 0,\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "group": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "type": 0,\\r\\n      "nature": 0,\\r\\n      "name": "",\\r\\n      "p_name": "",\\r\\n      "hsn": "",\\r\\n      "gstrate": 0,\\r\\n      "itcrate": 0,\\r\\n      "unit": {\\r\\n        "id": "",\\r\\n        "code": 0,\\r\\n        "name": "",\\r\\n        "digits": 0\\r\\n      },\\r\\n      "subunit": {\\r\\n        "id": "",\\r\\n        "code": 0,\\r\\n        "name": "",\\r\\n        "digits": 0\\r\\n      },\\r\\n      "conv_fact": 0,\\r\\n      "has_bom": false,\\r\\n      "sysobj": false\\r\\n    },\\r\\n    "design": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "color": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "status": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "quality": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "category": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "brand": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "print_name": ""\\r\\n    },\\r\\n    "style": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "p_name": ""\\r\\n    },\\r\\n    "unit": {\\r\\n      "id": "",\\r\\n      "code": 0,\\r\\n      "name": "",\\r\\n      "digits": 0\\r\\n    },\\r\\n    "rate": 0,\\r\\n    "min_qty": 0,\\r\\n    "max_qty": 0,\\r\\n    "wgt": 0\\r\\n  },\\r\\n  "fab_waste_wgt": 0,\\r\\n  "defects_count": 0,\\r\\n  "remarks": ""\\r\\n}',
            'IntegratedSecurity': false,
            'Prompt': '',
            'Collation': '',
            'AccentSensivity': 'Auto',
            'WidthSensivity': 'Auto'
          }
        }],
        'DataSets': [{
          'Name': 'DataSet',
          'Fields': [{ 'Name': 'id', 'DataField': 'id' }, { 'Name': 'code', 'DataField': 'code' }, {
            'Name': 'status',
            'DataField': 'status'
          }, { 'Name': 'type', 'DataField': 'type' }, { 'Name': 'is_cr', 'DataField': 'is_cr' }, {
            'Name': 'finyear',
            'DataField': 'finyear'
          }, { 'Name': 'doc_no', 'DataField': 'doc_no' }, {
            'Name': 'machine.id',
            'DataField': 'machine.id'
          }, { 'Name': 'machine.code', 'DataField': 'machine.code' }, {
            'Name': 'machine.type',
            'DataField': 'machine.type'
          }, { 'Name': 'machine.nature', 'DataField': 'machine.nature' }, {
            'Name': 'machine.name',
            'DataField': 'machine.name'
          }, { 'Name': 'machine.p_name', 'DataField': 'machine.p_name' }, {
            'Name': 'shift.id',
            'DataField': 'shift.id'
          }, { 'Name': 'shift.code', 'DataField': 'shift.code' }, {
            'Name': 'shift.type',
            'DataField': 'shift.type'
          }, { 'Name': 'shift.name', 'DataField': 'shift.name' }, {
            'Name': 'operator.id',
            'DataField': 'operator.id'
          }, { 'Name': 'operator.code', 'DataField': 'operator.code' }, {
            'Name': 'operator.status',
            'DataField': 'operator.status'
          }, { 'Name': 'operator.emp_code', 'DataField': 'operator.emp_code' }, {
            'Name': 'operator.name',
            'DataField': 'operator.name'
          }, {
            'Name': 'operator.designation.id',
            'DataField': 'operator.designation.id'
          }, {
            'Name': 'operator.designation.code',
            'DataField': 'operator.designation.code'
          }, {
            'Name': 'operator.designation.name',
            'DataField': 'operator.designation.name'
          }, {
            'Name': 'operator.designation.min_wage',
            'DataField': 'operator.designation.min_wage'
          }, { 'Name': 'date', 'DataField': 'date' }, {
            'Name': 'color.id',
            'DataField': 'color.id'
          }, { 'Name': 'color.code', 'DataField': 'color.code' }, {
            'Name': 'color.status',
            'DataField': 'color.status'
          }, { 'Name': 'color.name', 'DataField': 'color.name' }, {
            'Name': 'color.p_name',
            'DataField': 'color.p_name'
          }, { 'Name': 'color.wgt', 'DataField': 'color.wgt' }, {
            'Name': 'color.chart',
            'DataField': 'color.chart'
          }, { 'Name': 'quality.id', 'DataField': 'quality.id' }, {
            'Name': 'quality.code',
            'DataField': 'quality.code'
          }, { 'Name': 'quality.name', 'DataField': 'quality.name' }, {
            'Name': 'quality.p_name',
            'DataField': 'quality.p_name'
          }, { 'Name': 'quality.colors_wgt', 'DataField': 'quality.colors_wgt' }, {
            'Name': 'fabric.id',
            'DataField': 'fabric.id'
          }, { 'Name': 'fabric.code', 'DataField': 'fabric.code' }, {
            'Name': 'fabric.nature',
            'DataField': 'fabric.nature'
          }, {
            'Name': 'fabric.ledger_group.id',
            'DataField': 'fabric.ledger_group.id'
          }, {
            'Name': 'fabric.ledger_group.code',
            'DataField': 'fabric.ledger_group.code'
          }, {
            'Name': 'fabric.ledger_group.status',
            'DataField': 'fabric.ledger_group.status'
          }, {
            'Name': 'fabric.ledger_group.type',
            'DataField': 'fabric.ledger_group.type'
          }, {
            'Name': 'fabric.ledger_group.name',
            'DataField': 'fabric.ledger_group.name'
          }, {
            'Name': 'fabric.ledger_group.alias',
            'DataField': 'fabric.ledger_group.alias'
          }, {
            'Name': 'fabric.ledger_group.print_name',
            'DataField': 'fabric.ledger_group.print_name'
          }, {
            'Name': 'fabric.ledger_group.parent_code',
            'DataField': 'fabric.ledger_group.parent_code'
          }, {
            'Name': 'fabric.ledger_group.nature',
            'DataField': 'fabric.ledger_group.nature'
          }, {
            'Name': 'fabric.ledger_group.affect_profit',
            'DataField': 'fabric.ledger_group.affect_profit'
          }, {
            'Name': 'fabric.ledger_group.behave_like_sub_ledger',
            'DataField': 'fabric.ledger_group.behave_like_sub_ledger'
          }, {
            'Name': 'fabric.ledger_group.net_cr_dr_balance',
            'DataField': 'fabric.ledger_group.net_cr_dr_balance'
          }, {
            'Name': 'fabric.ledger_group.used_for_calculation',
            'DataField': 'fabric.ledger_group.used_for_calculation'
          }, {
            'Name': 'fabric.ledger_group.system_object',
            'DataField': 'fabric.ledger_group.system_object'
          }, { 'Name': 'fabric.name', 'DataField': 'fabric.name' }, {
            'Name': 'fabric.p_name',
            'DataField': 'fabric.p_name'
          }, { 'Name': 'fabric.process.id', 'DataField': 'fabric.process.id' }, {
            'Name': 'fabric.process.code',
            'DataField': 'fabric.process.code'
          }, { 'Name': 'fabric.process.name', 'DataField': 'fabric.process.name' }, {
            'Name': 'fabric.process.nature',
            'DataField': 'fabric.process.nature'
          }, { 'Name': 'fabric.process.p_name', 'DataField': 'fabric.process.p_name' }, {
            'Name': 'fabric.group.id',
            'DataField': 'fabric.group.id'
          }, { 'Name': 'fabric.group.code', 'DataField': 'fabric.group.code' }, {
            'Name': 'fabric.group.type',
            'DataField': 'fabric.group.type'
          }, { 'Name': 'fabric.group.nature', 'DataField': 'fabric.group.nature' }, {
            'Name': 'fabric.group.name',
            'DataField': 'fabric.group.name'
          }, { 'Name': 'fabric.group.p_name', 'DataField': 'fabric.group.p_name' }, {
            'Name': 'fabric.group.hsn',
            'DataField': 'fabric.group.hsn'
          }, { 'Name': 'fabric.group.gstrate', 'DataField': 'fabric.group.gstrate' }, {
            'Name': 'fabric.group.itcrate',
            'DataField': 'fabric.group.itcrate'
          }, {
            'Name': 'fabric.group.unit.id',
            'DataField': 'fabric.group.unit.id'
          }, {
            'Name': 'fabric.group.unit.code',
            'DataField': 'fabric.group.unit.code'
          }, {
            'Name': 'fabric.group.unit.name',
            'DataField': 'fabric.group.unit.name'
          }, {
            'Name': 'fabric.group.unit.digits',
            'DataField': 'fabric.group.unit.digits'
          }, {
            'Name': 'fabric.group.subunit.id',
            'DataField': 'fabric.group.subunit.id'
          }, {
            'Name': 'fabric.group.subunit.code',
            'DataField': 'fabric.group.subunit.code'
          }, {
            'Name': 'fabric.group.subunit.name',
            'DataField': 'fabric.group.subunit.name'
          }, {
            'Name': 'fabric.group.subunit.digits',
            'DataField': 'fabric.group.subunit.digits'
          }, {
            'Name': 'fabric.group.conv_fact',
            'DataField': 'fabric.group.conv_fact'
          }, { 'Name': 'fabric.group.has_bom', 'DataField': 'fabric.group.has_bom' }, {
            'Name': 'fabric.group.sysobj',
            'DataField': 'fabric.group.sysobj'
          }, { 'Name': 'fabric.design.id', 'DataField': 'fabric.design.id' }, {
            'Name': 'fabric.design.code',
            'DataField': 'fabric.design.code'
          }, { 'Name': 'fabric.design.name', 'DataField': 'fabric.design.name' }, {
            'Name': 'fabric.design.p_name',
            'DataField': 'fabric.design.p_name'
          }, { 'Name': 'fabric.color.id', 'DataField': 'fabric.color.id' }, {
            'Name': 'fabric.color.code',
            'DataField': 'fabric.color.code'
          }, { 'Name': 'fabric.color.status', 'DataField': 'fabric.color.status' }, {
            'Name': 'fabric.color.name',
            'DataField': 'fabric.color.name'
          }, { 'Name': 'fabric.color.p_name', 'DataField': 'fabric.color.p_name' }, {
            'Name': 'fabric.quality.id',
            'DataField': 'fabric.quality.id'
          }, { 'Name': 'fabric.quality.code', 'DataField': 'fabric.quality.code' }, {
            'Name': 'fabric.quality.name',
            'DataField': 'fabric.quality.name'
          }, { 'Name': 'fabric.quality.p_name', 'DataField': 'fabric.quality.p_name' }, {
            'Name': 'fabric.category.id',
            'DataField': 'fabric.category.id'
          }, { 'Name': 'fabric.category.code', 'DataField': 'fabric.category.code' }, {
            'Name': 'fabric.category.name',
            'DataField': 'fabric.category.name'
          }, { 'Name': 'fabric.category.p_name', 'DataField': 'fabric.category.p_name' }, {
            'Name': 'fabric.brand.id',
            'DataField': 'fabric.brand.id'
          }, { 'Name': 'fabric.brand.code', 'DataField': 'fabric.brand.code' }, {
            'Name': 'fabric.brand.name',
            'DataField': 'fabric.brand.name'
          }, { 'Name': 'fabric.brand.print_name', 'DataField': 'fabric.brand.print_name' }, {
            'Name': 'fabric.style.id',
            'DataField': 'fabric.style.id'
          }, { 'Name': 'fabric.style.code', 'DataField': 'fabric.style.code' }, {
            'Name': 'fabric.style.name',
            'DataField': 'fabric.style.name'
          }, { 'Name': 'fabric.style.p_name', 'DataField': 'fabric.style.p_name' }, {
            'Name': 'fabric.unit.id',
            'DataField': 'fabric.unit.id'
          }, { 'Name': 'fabric.unit.code', 'DataField': 'fabric.unit.code' }, {
            'Name': 'fabric.unit.name',
            'DataField': 'fabric.unit.name'
          }, { 'Name': 'fabric.unit.digits', 'DataField': 'fabric.unit.digits' }, {
            'Name': 'fabric.rate',
            'DataField': 'fabric.rate'
          }, { 'Name': 'fabric.min_qty', 'DataField': 'fabric.min_qty' }, {
            'Name': 'fabric.max_qty',
            'DataField': 'fabric.max_qty'
          }, { 'Name': 'fabric.wgt', 'DataField': 'fabric.wgt' }, {
            'Name': 'fab_wgt',
            'DataField': 'fab_wgt'
          }, { 'Name': 'yarn_waste.id', 'DataField': 'yarn_waste.id' }, {
            'Name': 'yarn_waste.code',
            'DataField': 'yarn_waste.code'
          }, { 'Name': 'yarn_waste.nature', 'DataField': 'yarn_waste.nature' }, {
            'Name': 'yarn_waste.ledger_group.id',
            'DataField': 'yarn_waste.ledger_group.id'
          }, {
            'Name': 'yarn_waste.ledger_group.code',
            'DataField': 'yarn_waste.ledger_group.code'
          }, {
            'Name': 'yarn_waste.ledger_group.status',
            'DataField': 'yarn_waste.ledger_group.status'
          }, {
            'Name': 'yarn_waste.ledger_group.type',
            'DataField': 'yarn_waste.ledger_group.type'
          }, {
            'Name': 'yarn_waste.ledger_group.name',
            'DataField': 'yarn_waste.ledger_group.name'
          }, {
            'Name': 'yarn_waste.ledger_group.alias',
            'DataField': 'yarn_waste.ledger_group.alias'
          }, {
            'Name': 'yarn_waste.ledger_group.print_name',
            'DataField': 'yarn_waste.ledger_group.print_name'
          }, {
            'Name': 'yarn_waste.ledger_group.parent_code',
            'DataField': 'yarn_waste.ledger_group.parent_code'
          }, {
            'Name': 'yarn_waste.ledger_group.nature',
            'DataField': 'yarn_waste.ledger_group.nature'
          }, {
            'Name': 'yarn_waste.ledger_group.affect_profit',
            'DataField': 'yarn_waste.ledger_group.affect_profit'
          }, {
            'Name': 'yarn_waste.ledger_group.behave_like_sub_ledger',
            'DataField': 'yarn_waste.ledger_group.behave_like_sub_ledger'
          }, {
            'Name': 'yarn_waste.ledger_group.net_cr_dr_balance',
            'DataField': 'yarn_waste.ledger_group.net_cr_dr_balance'
          }, {
            'Name': 'yarn_waste.ledger_group.used_for_calculation',
            'DataField': 'yarn_waste.ledger_group.used_for_calculation'
          }, {
            'Name': 'yarn_waste.ledger_group.system_object',
            'DataField': 'yarn_waste.ledger_group.system_object'
          }, { 'Name': 'yarn_waste.name', 'DataField': 'yarn_waste.name' }, {
            'Name': 'yarn_waste.p_name',
            'DataField': 'yarn_waste.p_name'
          }, {
            'Name': 'yarn_waste.process.id',
            'DataField': 'yarn_waste.process.id'
          }, {
            'Name': 'yarn_waste.process.code',
            'DataField': 'yarn_waste.process.code'
          }, {
            'Name': 'yarn_waste.process.name',
            'DataField': 'yarn_waste.process.name'
          }, {
            'Name': 'yarn_waste.process.nature',
            'DataField': 'yarn_waste.process.nature'
          }, {
            'Name': 'yarn_waste.process.p_name',
            'DataField': 'yarn_waste.process.p_name'
          }, { 'Name': 'yarn_waste.group.id', 'DataField': 'yarn_waste.group.id' }, {
            'Name': 'yarn_waste.group.code',
            'DataField': 'yarn_waste.group.code'
          }, {
            'Name': 'yarn_waste.group.type',
            'DataField': 'yarn_waste.group.type'
          }, {
            'Name': 'yarn_waste.group.nature',
            'DataField': 'yarn_waste.group.nature'
          }, {
            'Name': 'yarn_waste.group.name',
            'DataField': 'yarn_waste.group.name'
          }, {
            'Name': 'yarn_waste.group.p_name',
            'DataField': 'yarn_waste.group.p_name'
          }, {
            'Name': 'yarn_waste.group.hsn',
            'DataField': 'yarn_waste.group.hsn'
          }, {
            'Name': 'yarn_waste.group.gstrate',
            'DataField': 'yarn_waste.group.gstrate'
          }, {
            'Name': 'yarn_waste.group.itcrate',
            'DataField': 'yarn_waste.group.itcrate'
          }, {
            'Name': 'yarn_waste.group.unit.id',
            'DataField': 'yarn_waste.group.unit.id'
          }, {
            'Name': 'yarn_waste.group.unit.code',
            'DataField': 'yarn_waste.group.unit.code'
          }, {
            'Name': 'yarn_waste.group.unit.name',
            'DataField': 'yarn_waste.group.unit.name'
          }, {
            'Name': 'yarn_waste.group.unit.digits',
            'DataField': 'yarn_waste.group.unit.digits'
          }, {
            'Name': 'yarn_waste.group.subunit.id',
            'DataField': 'yarn_waste.group.subunit.id'
          }, {
            'Name': 'yarn_waste.group.subunit.code',
            'DataField': 'yarn_waste.group.subunit.code'
          }, {
            'Name': 'yarn_waste.group.subunit.name',
            'DataField': 'yarn_waste.group.subunit.name'
          }, {
            'Name': 'yarn_waste.group.subunit.digits',
            'DataField': 'yarn_waste.group.subunit.digits'
          }, {
            'Name': 'yarn_waste.group.conv_fact',
            'DataField': 'yarn_waste.group.conv_fact'
          }, {
            'Name': 'yarn_waste.group.has_bom',
            'DataField': 'yarn_waste.group.has_bom'
          }, {
            'Name': 'yarn_waste.group.sysobj',
            'DataField': 'yarn_waste.group.sysobj'
          }, {
            'Name': 'yarn_waste.design.id',
            'DataField': 'yarn_waste.design.id'
          }, {
            'Name': 'yarn_waste.design.code',
            'DataField': 'yarn_waste.design.code'
          }, {
            'Name': 'yarn_waste.design.name',
            'DataField': 'yarn_waste.design.name'
          }, {
            'Name': 'yarn_waste.design.p_name',
            'DataField': 'yarn_waste.design.p_name'
          }, { 'Name': 'yarn_waste.color.id', 'DataField': 'yarn_waste.color.id' }, {
            'Name': 'yarn_waste.color.code',
            'DataField': 'yarn_waste.color.code'
          }, {
            'Name': 'yarn_waste.color.status',
            'DataField': 'yarn_waste.color.status'
          }, {
            'Name': 'yarn_waste.color.name',
            'DataField': 'yarn_waste.color.name'
          }, {
            'Name': 'yarn_waste.color.p_name',
            'DataField': 'yarn_waste.color.p_name'
          }, {
            'Name': 'yarn_waste.quality.id',
            'DataField': 'yarn_waste.quality.id'
          }, {
            'Name': 'yarn_waste.quality.code',
            'DataField': 'yarn_waste.quality.code'
          }, {
            'Name': 'yarn_waste.quality.name',
            'DataField': 'yarn_waste.quality.name'
          }, {
            'Name': 'yarn_waste.quality.p_name',
            'DataField': 'yarn_waste.quality.p_name'
          }, {
            'Name': 'yarn_waste.category.id',
            'DataField': 'yarn_waste.category.id'
          }, {
            'Name': 'yarn_waste.category.code',
            'DataField': 'yarn_waste.category.code'
          }, {
            'Name': 'yarn_waste.category.name',
            'DataField': 'yarn_waste.category.name'
          }, {
            'Name': 'yarn_waste.category.p_name',
            'DataField': 'yarn_waste.category.p_name'
          }, { 'Name': 'yarn_waste.brand.id', 'DataField': 'yarn_waste.brand.id' }, {
            'Name': 'yarn_waste.brand.code',
            'DataField': 'yarn_waste.brand.code'
          }, {
            'Name': 'yarn_waste.brand.name',
            'DataField': 'yarn_waste.brand.name'
          }, {
            'Name': 'yarn_waste.brand.print_name',
            'DataField': 'yarn_waste.brand.print_name'
          }, { 'Name': 'yarn_waste.style.id', 'DataField': 'yarn_waste.style.id' }, {
            'Name': 'yarn_waste.style.code',
            'DataField': 'yarn_waste.style.code'
          }, {
            'Name': 'yarn_waste.style.name',
            'DataField': 'yarn_waste.style.name'
          }, {
            'Name': 'yarn_waste.style.p_name',
            'DataField': 'yarn_waste.style.p_name'
          }, { 'Name': 'yarn_waste.unit.id', 'DataField': 'yarn_waste.unit.id' }, {
            'Name': 'yarn_waste.unit.code',
            'DataField': 'yarn_waste.unit.code'
          }, {
            'Name': 'yarn_waste.unit.name',
            'DataField': 'yarn_waste.unit.name'
          }, { 'Name': 'yarn_waste.unit.digits', 'DataField': 'yarn_waste.unit.digits' }, {
            'Name': 'yarn_waste.rate',
            'DataField': 'yarn_waste.rate'
          }, { 'Name': 'yarn_waste.min_qty', 'DataField': 'yarn_waste.min_qty' }, {
            'Name': 'yarn_waste.max_qty',
            'DataField': 'yarn_waste.max_qty'
          }, { 'Name': 'yarn_waste.wgt', 'DataField': 'yarn_waste.wgt' }, {
            'Name': 'yarn_waste_wgt',
            'DataField': 'yarn_waste_wgt'
          }, { 'Name': 'fab_waste.id', 'DataField': 'fab_waste.id' }, {
            'Name': 'fab_waste.code',
            'DataField': 'fab_waste.code'
          }, { 'Name': 'fab_waste.nature', 'DataField': 'fab_waste.nature' }, {
            'Name': 'fab_waste.ledger_group.id',
            'DataField': 'fab_waste.ledger_group.id'
          }, {
            'Name': 'fab_waste.ledger_group.code',
            'DataField': 'fab_waste.ledger_group.code'
          }, {
            'Name': 'fab_waste.ledger_group.status',
            'DataField': 'fab_waste.ledger_group.status'
          }, {
            'Name': 'fab_waste.ledger_group.type',
            'DataField': 'fab_waste.ledger_group.type'
          }, {
            'Name': 'fab_waste.ledger_group.name',
            'DataField': 'fab_waste.ledger_group.name'
          }, {
            'Name': 'fab_waste.ledger_group.alias',
            'DataField': 'fab_waste.ledger_group.alias'
          }, {
            'Name': 'fab_waste.ledger_group.print_name',
            'DataField': 'fab_waste.ledger_group.print_name'
          }, {
            'Name': 'fab_waste.ledger_group.parent_code',
            'DataField': 'fab_waste.ledger_group.parent_code'
          }, {
            'Name': 'fab_waste.ledger_group.nature',
            'DataField': 'fab_waste.ledger_group.nature'
          }, {
            'Name': 'fab_waste.ledger_group.affect_profit',
            'DataField': 'fab_waste.ledger_group.affect_profit'
          }, {
            'Name': 'fab_waste.ledger_group.behave_like_sub_ledger',
            'DataField': 'fab_waste.ledger_group.behave_like_sub_ledger'
          }, {
            'Name': 'fab_waste.ledger_group.net_cr_dr_balance',
            'DataField': 'fab_waste.ledger_group.net_cr_dr_balance'
          }, {
            'Name': 'fab_waste.ledger_group.used_for_calculation',
            'DataField': 'fab_waste.ledger_group.used_for_calculation'
          }, {
            'Name': 'fab_waste.ledger_group.system_object',
            'DataField': 'fab_waste.ledger_group.system_object'
          }, { 'Name': 'fab_waste.name', 'DataField': 'fab_waste.name' }, {
            'Name': 'fab_waste.p_name',
            'DataField': 'fab_waste.p_name'
          }, {
            'Name': 'fab_waste.process.id',
            'DataField': 'fab_waste.process.id'
          }, {
            'Name': 'fab_waste.process.code',
            'DataField': 'fab_waste.process.code'
          }, {
            'Name': 'fab_waste.process.name',
            'DataField': 'fab_waste.process.name'
          }, {
            'Name': 'fab_waste.process.nature',
            'DataField': 'fab_waste.process.nature'
          }, {
            'Name': 'fab_waste.process.p_name',
            'DataField': 'fab_waste.process.p_name'
          }, { 'Name': 'fab_waste.group.id', 'DataField': 'fab_waste.group.id' }, {
            'Name': 'fab_waste.group.code',
            'DataField': 'fab_waste.group.code'
          }, {
            'Name': 'fab_waste.group.type',
            'DataField': 'fab_waste.group.type'
          }, {
            'Name': 'fab_waste.group.nature',
            'DataField': 'fab_waste.group.nature'
          }, {
            'Name': 'fab_waste.group.name',
            'DataField': 'fab_waste.group.name'
          }, {
            'Name': 'fab_waste.group.p_name',
            'DataField': 'fab_waste.group.p_name'
          }, { 'Name': 'fab_waste.group.hsn', 'DataField': 'fab_waste.group.hsn' }, {
            'Name': 'fab_waste.group.gstrate',
            'DataField': 'fab_waste.group.gstrate'
          }, {
            'Name': 'fab_waste.group.itcrate',
            'DataField': 'fab_waste.group.itcrate'
          }, {
            'Name': 'fab_waste.group.unit.id',
            'DataField': 'fab_waste.group.unit.id'
          }, {
            'Name': 'fab_waste.group.unit.code',
            'DataField': 'fab_waste.group.unit.code'
          }, {
            'Name': 'fab_waste.group.unit.name',
            'DataField': 'fab_waste.group.unit.name'
          }, {
            'Name': 'fab_waste.group.unit.digits',
            'DataField': 'fab_waste.group.unit.digits'
          }, {
            'Name': 'fab_waste.group.subunit.id',
            'DataField': 'fab_waste.group.subunit.id'
          }, {
            'Name': 'fab_waste.group.subunit.code',
            'DataField': 'fab_waste.group.subunit.code'
          }, {
            'Name': 'fab_waste.group.subunit.name',
            'DataField': 'fab_waste.group.subunit.name'
          }, {
            'Name': 'fab_waste.group.subunit.digits',
            'DataField': 'fab_waste.group.subunit.digits'
          }, {
            'Name': 'fab_waste.group.conv_fact',
            'DataField': 'fab_waste.group.conv_fact'
          }, {
            'Name': 'fab_waste.group.has_bom',
            'DataField': 'fab_waste.group.has_bom'
          }, {
            'Name': 'fab_waste.group.sysobj',
            'DataField': 'fab_waste.group.sysobj'
          }, { 'Name': 'fab_waste.design.id', 'DataField': 'fab_waste.design.id' }, {
            'Name': 'fab_waste.design.code',
            'DataField': 'fab_waste.design.code'
          }, {
            'Name': 'fab_waste.design.name',
            'DataField': 'fab_waste.design.name'
          }, {
            'Name': 'fab_waste.design.p_name',
            'DataField': 'fab_waste.design.p_name'
          }, { 'Name': 'fab_waste.color.id', 'DataField': 'fab_waste.color.id' }, {
            'Name': 'fab_waste.color.code',
            'DataField': 'fab_waste.color.code'
          }, {
            'Name': 'fab_waste.color.status',
            'DataField': 'fab_waste.color.status'
          }, {
            'Name': 'fab_waste.color.name',
            'DataField': 'fab_waste.color.name'
          }, {
            'Name': 'fab_waste.color.p_name',
            'DataField': 'fab_waste.color.p_name'
          }, {
            'Name': 'fab_waste.quality.id',
            'DataField': 'fab_waste.quality.id'
          }, {
            'Name': 'fab_waste.quality.code',
            'DataField': 'fab_waste.quality.code'
          }, {
            'Name': 'fab_waste.quality.name',
            'DataField': 'fab_waste.quality.name'
          }, {
            'Name': 'fab_waste.quality.p_name',
            'DataField': 'fab_waste.quality.p_name'
          }, {
            'Name': 'fab_waste.category.id',
            'DataField': 'fab_waste.category.id'
          }, {
            'Name': 'fab_waste.category.code',
            'DataField': 'fab_waste.category.code'
          }, {
            'Name': 'fab_waste.category.name',
            'DataField': 'fab_waste.category.name'
          }, {
            'Name': 'fab_waste.category.p_name',
            'DataField': 'fab_waste.category.p_name'
          }, { 'Name': 'fab_waste.brand.id', 'DataField': 'fab_waste.brand.id' }, {
            'Name': 'fab_waste.brand.code',
            'DataField': 'fab_waste.brand.code'
          }, {
            'Name': 'fab_waste.brand.name',
            'DataField': 'fab_waste.brand.name'
          }, {
            'Name': 'fab_waste.brand.print_name',
            'DataField': 'fab_waste.brand.print_name'
          }, { 'Name': 'fab_waste.style.id', 'DataField': 'fab_waste.style.id' }, {
            'Name': 'fab_waste.style.code',
            'DataField': 'fab_waste.style.code'
          }, {
            'Name': 'fab_waste.style.name',
            'DataField': 'fab_waste.style.name'
          }, { 'Name': 'fab_waste.style.p_name', 'DataField': 'fab_waste.style.p_name' }, {
            'Name': 'fab_waste.unit.id',
            'DataField': 'fab_waste.unit.id'
          }, { 'Name': 'fab_waste.unit.code', 'DataField': 'fab_waste.unit.code' }, {
            'Name': 'fab_waste.unit.name',
            'DataField': 'fab_waste.unit.name'
          }, { 'Name': 'fab_waste.unit.digits', 'DataField': 'fab_waste.unit.digits' }, {
            'Name': 'fab_waste.rate',
            'DataField': 'fab_waste.rate'
          }, { 'Name': 'fab_waste.min_qty', 'DataField': 'fab_waste.min_qty' }, {
            'Name': 'fab_waste.max_qty',
            'DataField': 'fab_waste.max_qty'
          }, { 'Name': 'fab_waste.wgt', 'DataField': 'fab_waste.wgt' }, {
            'Name': 'fab_waste_wgt',
            'DataField': 'fab_waste_wgt'
          }, { 'Name': 'defects_count', 'DataField': 'defects_count' }, { 'Name': 'remarks', 'DataField': 'remarks' }],
          'Query': { 'DataSourceName': 'DataSource', 'CommandType': 'Text', 'CommandText': 'jpath=$', 'Timeout': 0 },
          'CaseSensitivity': 'Auto',
          'Collation': '',
          'KanatypeSensitivity': 'Auto',
          'AccentSensitivity': 'Auto',
          'WidthSensitivity': 'Auto'
        }],
        'DataElementName': 'BarcodeLabel',
        'DataElementStyle': 'Auto'
      }
      report.DataSources[0].ConnectionProperties.ConnectString = 'jsondata=' + JSON.stringify(self.$data.voucher)

    },
    showModal () {
      $('#rolling_window').modal('hide')
    },
    clear () {
      this.voucher = JSON.parse('{"id":0,"status":"Active","finyear":0,"cmp_id":1,"shift":{"id":0,"type":0,"name":""},"doc_date":"2000-01-01","roll_no":0,"old_roll_no":0,"emp_id":0,"emp":{"id":0,"status":0,"emp_code":"","name":""},"process_id":0,"process":{"code":350,"name":"","nature":0},"quality":{"id":0,"name":""},"color":{"id":0,"status":0,"name":""},"qty":0,"weight":0,"avg":0,"list":[],"remarks":""}');
    },
    modifyDocument (id) {
      const self = this

      const requestOptions = {
        method: 'GET',
        mode: 'cors',
        headers: userService.authHeader()
      }


      block_el('#mycard');

      self.$data.voucher = JSON.parse('{"id":0,"status":"Active","finyear":0,"cmp_id":1,"shift":{"id":0,"type":0,"name":""},"doc_date":"2000-01-01","roll_no":0,"old_roll_no":0,"emp_id":0,"emp":{"id":0,"status":0,"emp_code":"","name":""},"process_id":0,"process":{"code":350,"name":"","nature":0},"quality":{"id":0,"name":""},"color":{"id":0,"status":0,"name":""},"qty":0,"weight":0,"avg":0,"list":[],"remarks":""}');
      fetch(`${process.env.VUE_APP_ROOT_API}api/roll/${id}`, requestOptions).then(userService.handleResponse).then(function (resp) {
        if (resp.ok) {
          if (!_.isNull(resp.data)) {

            self.$data.voucher = resp.data;

            self.$modal.show('rolling_window');
          }
        } else {
          swal({ title: 'Oops!', text: resp.msg, type: 'error' })
        }
      }).catch(function (err) {
        swal({ title: 'Oh noes!', text: err.toString(), type: 'error' })
      }).finally(()=>{
        unblock_el('#mycard');
      });
    },
    removeDocument (id) {
      const self = this

      self.$data.voucher.id = id

      const requestOptions = {
        method: 'DELETE',
        mode: 'cors',
        headers: userService.authHeader(),
        body: JSON.stringify(self.$data.voucher)
      }

      swal({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        type: 'warning',
        timer: 3000,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete this!'
      }).then((result) => {
        if (result.value) {
          fetch(`${process.env.VUE_APP_ROOT_API}api/roll`, requestOptions).then(userService.handleResponse).then(function (resp) {
            self.$modal.hide('rolling_window')
            self.loadData()
            swal(
              'Deleted!',
              'Your request has been processed',
              'success'
            )
          }).catch(function (err) {
            swal({ title: 'Oops', text: err.toString(), type: 'error', timer:3000 })
          })
        }
      })

    },
    loadData () {
      const self = this;

      const requestOptions = {
        method: 'GET',
        mode: 'cors',
        headers: userService.authHeader()
      }

      $('#txtsearch').val('');
      this.$modal.hide('rolling_window');

      $(self.$data.mytable).block({
        message: '<i class="icon-spinner2 spinner"></i>',
        overlayCSS: {
          backgroundColor: '#fff',
          opacity: 0.8,
          cursor: 'wait',
          'box-shadow': '0 0 0 1px #ddd'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'none'
        }
      })

      self.$modal.hide('filter-window');
      self.$data.mytable.bootstrapTable('load', [])
      self.$data.mytable.bootstrapTable('showLoading')

      let filters = `vchtype=New&from=${self.from_date}&upto=${self.upto_date}&quality_id=${self.quality_id}&color_id=${self.color_id}`;


      fetch(`${process.env.VUE_APP_ROOT_API}api/rolls?${filters}`, requestOptions).then(userService.handleResponse).then(function (resp) {
        if (resp.ok) {

          if (_.isArray(resp.data)) {
            self.$data.mytable.bootstrapTable('load', resp.data);
          }
        } else {
          swal({ title: 'Oops!', text: resp.msg, type: 'error', timer:3000 });
        }
      }).catch(function (err) {
        swal({ title: 'Oh noes!', text: err.toString(), type: 'error', timer:3000 });
      }).finally(function () {
        self.$data.mytable.bootstrapTable('hideLoading');
        $(self.$data.mytable).unblock()
      });
    },

    loadFilterData(){
      const self = this;

      const requestOptions = {
        method: 'GET',
        mode:"cors",
        headers: userService.authHeader()
      };


      //Load Qualities
      self.$data.qualities = [];
      fetch(`${process.env.VUE_APP_ROOT_API}api/qualities/after/1`,requestOptions).then(userService.handleResponse).then(function (resp) {
        if(resp.ok) {
          if(resp.data != null){
            self.$data.qualities = resp.data;
          }
        } else {
          swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
        }
      }).catch(function (err) {
        swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
      });


      //Load Colors
      self.$data.colors = [];
      fetch(`${process.env.VUE_APP_ROOT_API}api/colorcharts/after/1`,requestOptions).then(userService.handleResponse).then(function (resp) {
        if(resp.ok) {
          if(resp.data != null){
            self.$data.colors = resp.data;
          }
        } else {
          swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
        }
      }).catch(function (err) {
        swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
      });


    },
  }
}
</script>

<style scoped>
.modal-full {
  min-width: 100%;
  margin: 0;
}

.modal-full .modal-content {
  min-height: 100vh;
}

input:focus {
  background: #feff00;
}

textarea:focus {
  background: #feff00;
}

select:focus {
  background: #feff00;
}

button:focus {
  background: #feff00;
  color: #0a0a0a!important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
